"use client"

import { useEffect, useState } from "react"
import {
  Row,
  Col,
  Input,
  Menu,
  Select,
  Form,
  DatePicker,
  Button,
  Tooltip,
  Spin,
  Dropdown,
  message,
  Card,
  Tag,
  Drawer,
  Typography,
  Table,
  Modal,
} from "antd"
import ThemeJson from "../../constants/UIServer.json"
import listMode from "../../assets/images/viewFilter.svg"
import { useParams } from "react-router-dom"
import DashboardReport from "./DashboardReport"
import { getComboFillForReportIdAndValue, getComboFillForReportOnlyId } from "../../services/generic"
import arrowIcon from "../../assets/images/selArrow.svg"
import clearReportData from "../../assets/images/filterDefault.svg"
import { LoadingOutlined, CalendarOutlined, EditOutlined, DeleteOutlined, DownloadOutlined } from "@ant-design/icons"
import { generateToken } from "../../services/generateToken"
import { getOAuthHeaders } from "../../constants/oAuthValidation"
import Axios from "axios"
import DrillDownTable from "./DrillDownTable"
import noRecord from "../../assets/images/noRecord.png"
import { useGlobalContext } from "../../lib/storage"
import ReportIcon from "../../assets/images/reportScheduler.svg"
import Close from "../../assets/images/close-x.svg"
import fullScreenIcon from "../../assets/images/modalMax.svg"
import closeIcon from "../../assets/images/closeIcon.svg"
import ExportPopup1 from "../../assets/images/exportPopup.svg"
import moment from "moment"
import { gridLogic } from "./gridLogic"
import TableForReport from "./TableForReport"
import AnalyticsReportTable from "./AnalyticsTable"
import PivotTableForAnalytics from "./pivotForAnalytics"
import ExportPopup from "../export-popup"
import * as XLSX from "xlsx"
import jsPDF from "jspdf"
import "jspdf-autotable"
// import XLSX from "xlsx"
import ExcelJS from "exceljs"

const { RangePicker } = DatePicker
const { Option } = Select
const { Text } = Typography
const { TextArea } = Input

export default function AnalyticsReport({ reportData }) {
  console.log(reportData?.analyticsReportConfiguration, reportData?.analyticsReportConfiguration?.type)
  const { reportId } = useParams()
  const [reportFilters, setReportFilters] = useState([])
  const [reportFiltersForNextRow, setReportFiltersForNextRow] = useState([])
  const [reportFiltersForDatePopup, setReportFiltersForDatePopup] = useState([])
  const [loading, setLoading] = useState(false)
  const [multiSelectorDropdownId, setMultiSelectorDropdownId] = useState("")
  const [dropdownDetails, setDropdownDetails] = useState([])
  const [referenceListDetails, setListReferenceDetails] = useState([]);
  const [drillDownHeader, setHeaderForDrillDown] = useState([])
  const [drillDownData, setDataForDrillDown] = useState([])
  const [drillDownPopup, setPopupForDrillDown] = useState(false)
  const [drillDownId, setDrillDownId] = useState("")
  const [selectedRecordToupdate, setSelectedRecordToUpdate] = useState(null)
  const [loadingForModal, setLoadingForModal] = useState(false)
  const [reportParameters, setReportParameters] = useState("")
  const [gridLength, setGridLength] = useState(0)
  const [drillDownTitle, setDrillDownTitle] = useState("")
  const [fullScreen, setFullScreen] = useState(false)
  const [popUpReportName, setPopUpReportName] = useState("")
  const [showExportPopup, setShowExportPopup] = useState(false)
  const [totalRecordsForDrillDown, setTotalRecordsForDrillDown] = useState(0)
  const [dateRangeColumnName, setDateRangeColumnName] = useState({ type: null, value: null })
  const [defaultValueExpression, setDefaultValueExpression] = useState(null)
  const [loadingForSReport, setloadingForSReport] = useState(false)
  const [reportDownloadFlag, setReportDownloadFlag] = useState(false)
  const [filterDropdownVisible, setFilterDropdownVisible] = useState(false)
  const [switchValue, setSwitchValue] = useState(false)
  const [nestedTable, setNestedTable] = useState("Y")
  const [detailedReportId, setDetailedReportId] = useState("")
  const [drillDownSelectedLevel, setDrillDownSelectedLevel] = useState(null)
  const [viewMoreLessFilters, setViewMoreLessFilters] = useState(false)
  const [totalRecords, setTotalRecords] = useState([])
  const [reportDateOptionsFlag, setReportDateOptionsFlag] = useState(false)
  const [buttonName, setButtonName] = useState("Today")
  const [gridData, setGridData] = useState([])
  const [headerData, setHeaderData] = useState([])
  const [basescreenFormData, setBasescreenFormData] = useState([])
  const [reportSchedulerVisible, setReportSchedulerVisible] = useState(false)
  const [scheduledData, setScheduledData] = useState([])
  const [scheduledReportFlag, setScheduledReportFlag] = useState(false)
  const [mainHeaderData, setMainHeaderData] = useState([])
  const [startDate, setStartDate] = useState(null)
  const [dateRange, setDateRange] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [pivotColumns, setPivotColumns] = useState([])
  const [showGridData, setShowGridData] = useState(false)
  const [parametersToSend, setParametersToSend] = useState({})
  const [reportName, setReportName] = useState(reportData?.analyticsReportConfiguration?.reportName || "")
  const [form] = Form.useForm()
  const [scheduleReportForm] = Form.useForm()
  const [reportFields, setReportFields] = useState([])
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [reportSelector, setReportSelector] = useState(null)
  const [isQuerySelectionAutoRun, setIsQuerySelectionAutoRun] = useState(false)
  const { globalStore } = useGlobalContext()
  const Themes = ThemeJson
  const genericUrl = process.env.REACT_APP_genericUrl
  const userData = globalStore.userData
  const userPreferences = globalStore.userPreferences
  const userCurrency = userData.currency
  const dateFormat = userPreferences.dateFormat
  const fileDownloadUrl = process.env.REACT_APP_fileDownloadUrl
  const appId = localStorage.getItem("appId")
  const [pivotExportData, setPivotExportData] = useState(null)

  const getRegularQueries = () => {
    return (
      reportData?.analyticsReportConfiguration?.queryConfiguration?.filter((query) => query.isDrilldownQuery !== "Y") ||
      []
    )
  }

  const getExistigScheduleData = () => {
    setloadingForSReport(true)
    const { access_token } = getOAuthHeaders()
    const getProducts = {
      query: `query{
          getScheduleReport(reportId:"${reportId}"){
          cSReportScheduleId
          frequency
          scheduleinfo
          startDate
          nextSchDate
          lastRunDate
          createdByName
      }
      }`,
    }
    Axios({
      url: genericUrl,
      method: "POST",
      data: getProducts,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${access_token}`,
        appId: appId,
      },
    }).then((response) => {
      if (response.status === 200) {
        const data = response.data.data.getScheduleReport
        for (let index = 0; index < data.length; index++) {
          data[index].srNo = index + 1
        }
        setScheduledData(data)
      }
      setloadingForSReport(false)
    })
  }

  useEffect(() => {
    setGridData([])
    setHeaderData([])
    setMainHeaderData([])
    setTotalRecords([])
    setPivotColumns([])
    setShowGridData(false)
    setParametersToSend({})
    setReportFilters([])
    setReportFiltersForDatePopup([])
    setReportFiltersForNextRow([])
    setMultiSelectorDropdownId("")
    setDropdownDetails([])
    setDateRangeColumnName({ type: null, value: null })
    setDefaultValueExpression(null)
    setReportDownloadFlag(false)
    setFilterDropdownVisible(false)
    setSwitchValue(false)
    setNestedTable("")
    setDetailedReportId("")
    setViewMoreLessFilters(false)
    setReportDateOptionsFlag(false)
    setButtonName("Today")
    setStartDate(null)
    setDateRange(null)
    setEndDate(null)
    setReportName(reportData?.analyticsReportConfiguration?.reportName || "")
    setReportSelector(null)
    setIsQuerySelectionAutoRun(false)
    form.resetFields()

    const autoRunJson = {}
    let dateTypeValue = {}
    const visibleFiltersArr = []
    const reportFilters = reportData?.analyticsReportConfiguration?.filtersConfiguration || []
    const reportSetting = reportData?.analyticsReportConfiguration?.advancedSettings || {}
    console.log(reportSetting)
    const enableschedulereport = reportSetting?.scheduling?.enabled
    // Set reportSelector automatically if there's only one non-drilldown query
    const nonDrilldownQueries =
      reportData?.analyticsReportConfiguration?.queryConfiguration?.filter((query) => query.isDrilldownQuery !== "Y") ||
      []

    if (reportData?.analyticsReportConfiguration?.type === "multilevel" && nonDrilldownQueries.length === 1) {
      setReportSelector(nonDrilldownQueries[0].id)
    }

    for (let index = 0; index < reportFilters.length; index++) {
      const element = reportFilters[index]
      if (element.isForPrompting === "Y" && element.isactive === "Y" && element.type !== "DateRange") {
        visibleFiltersArr.push(element)
      }
      if (element.isForPrompting === "Y" && element.isactive === "Y") {
        autoRunJson[element.columnName] = element.defaultValueExpression
      }
      if (element.type === "DateRange" || element.type === "DateTimeRange") {
        dateTypeValue = element.type
        setDateRangeColumnName({ type: element.type, value: element.columnName })
        setDefaultValueExpression(element.defaultValueExpression)
        const { defaultValueExpression } = element

        if (defaultValueExpression === "" || defaultValueExpression === undefined || defaultValueExpression === null) {
          const date = new Date()
          const year = date.getFullYear()
          const month = date.getMonth()
          const firstDay = dateConvertor(new Date(year, month, 1))
          const lastDay = dateConvertor(new Date(year, month + 1, 0))
          formattedDateForButton(firstDay, lastDay)
          form.setFieldsValue({
            [element.columnName]: [moment(new Date(firstDay), dateFormat), moment(new Date(lastDay), dateFormat)],
          })
        } else {
          switch (element.defaultValueExpression) {
            case "today":
              const monthNames = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ]
              const startDate = new Date()
              const startDateDay = startDate.getDate()
              const startDateMonth = monthNames[startDate.getMonth()]
              const startDateYear = startDate.getFullYear()
              const formattedStartDate = `${startDateDay}-${startDateMonth}-${startDateYear}`
              form.setFieldsValue({
                [element.columnName]: [
                  moment(new Date(startDate), dateFormat),
                  moment(new Date(startDate), dateFormat),
                ],
              })
              setButtonName(formattedStartDate)
              break
            case "yesterday":
              const monthNamesYesterday = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ]
              const yesterdaysDate = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
              const startDateDayYesterday = yesterdaysDate.getDate()
              const startDateMonthYesterday = monthNamesYesterday[yesterdaysDate.getMonth()]
              const startDateYearYesterday = yesterdaysDate.getFullYear()
              const formattedStartDateYesterday = `${startDateDayYesterday}-${startDateMonthYesterday}-${startDateYearYesterday}`
              form.setFieldsValue({
                [element.columnName]: [
                  moment(new Date(yesterdaysDate), dateFormat),
                  moment(new Date(yesterdaysDate), dateFormat),
                ],
              })
              setButtonName(formattedStartDateYesterday)
              break
            case "lastSevenDays":
              const currDate = new Date()
              const lastSevenDay = dateConvertor(new Date(Date.now() - 6 * 24 * 60 * 60 * 1000))
              form.setFieldsValue({
                [element.columnName]: [
                  moment(new Date(lastSevenDay), dateFormat),
                  moment(new Date(currDate), dateFormat),
                ],
              })
              formattedDateForButton(lastSevenDay, currDate)
              break
            case "lastThirtyDays":
              const currDateForThirtyDays = new Date()
              const last30Day = dateConvertor(new Date(Date.now() - 29 * 24 * 60 * 60 * 1000))
              form.setFieldsValue({
                [element.columnName]: [
                  moment(new Date(last30Day), dateFormat),
                  moment(new Date(currDateForThirtyDays), dateFormat),
                ],
              })
              formattedDateForButton(last30Day, currDateForThirtyDays)
              break
            case "lastNinetyDays":
              const startDateForLastNinetyDays = dateConvertor(moment().subtract(90, "days"))
              const endDateForLastNinetyDays = dateConvertor(new Date())
              formattedDateForButton(startDateForLastNinetyDays, endDateForLastNinetyDays)
              form.setFieldsValue({
                [element.columnName]: [
                  moment(new Date(startDateForLastNinetyDays), dateFormat),
                  moment(new Date(), dateFormat),
                ],
              })
              break
            case "lastMonth":
              const lastMonthDate = new Date()
              const lastMonthFirstDay = dateConvertor(
                new Date(lastMonthDate.getFullYear(), lastMonthDate.getMonth() - 1, 1),
              )
              const lastMonthLastDay = dateConvertor(new Date(lastMonthDate.getFullYear(), lastMonthDate.getMonth(), 0))
              form.setFieldsValue({
                [element.columnName]: [
                  moment(new Date(lastMonthFirstDay), dateFormat),
                  moment(new Date(lastMonthLastDay), dateFormat),
                ],
              })
              formattedDateForButton(lastMonthFirstDay, lastMonthLastDay)
              break
            case "lastYear":
              if (userCurrency === "INR") {
                const currDateCurrency = new Date()
                const fiscalYearFirstDay = dateConvertor(new Date(currDateCurrency.getFullYear() - 1, 3, 1))
                const fiscalYearLastDay = dateConvertor(new Date(currDateCurrency.getFullYear(), 2, 31))
                form.setFieldsValue({
                  [element.columnName]: [
                    moment(new Date(fiscalYearFirstDay), dateFormat),
                    moment(new Date(fiscalYearLastDay), dateFormat),
                  ],
                })
                formattedDateForButton(fiscalYearFirstDay, fiscalYearLastDay)
              } else {
                const lastYearDate = new Date(new Date().getFullYear() - 1, 0, 1)
                const lastYearFirstDay = dateConvertor(new Date(lastYearDate.getFullYear(), 0, 1))
                const lastYearLastDay = dateConvertor(new Date(lastYearDate.getFullYear(), 11, 31))
                form.setFieldsValue({
                  [element.columnName]: [
                    moment(new Date(lastYearFirstDay), dateFormat),
                    moment(new Date(lastYearLastDay), dateFormat),
                  ],
                })
                formattedDateForButton(lastYearFirstDay, lastYearLastDay)
              }
              break
            case "thisWeek":
              const curr = new Date()
              const week = []
              for (let i = 1; i <= 7; i++) {
                const first = curr.getDate() - curr.getDay() + i
                const day = new Date(curr.setDate(first)).toISOString().slice(0, 10)
                week.push(day)
              }
              const firstday = dateConvertor(week[0])
              const lastday = dateConvertor(new Date())
              formattedDateForButton(firstday, lastday)
              form.setFieldsValue({
                [element.columnName]: [moment(new Date(firstday), dateFormat), moment(new Date(), dateFormat)],
              })
              break
            case "thisMonth":
              const date = new Date()
              const year = date.getFullYear()
              const month = date.getMonth()
              const firstDay = dateConvertor(new Date(year, month, 1))
              const lastDay = dateConvertor(new Date())
              formattedDateForButton(firstDay, lastDay)
              form.setFieldsValue({
                [element.columnName]: [moment(new Date(firstDay), dateFormat), moment(new Date(lastDay), dateFormat)],
              })
              break
            case "thisQuarter":
              const startDateOfQuarter = dateConvertor(moment().startOf("quarter"))
              const endDateOfQuarter = dateConvertor(new Date())
              formattedDateForButton(startDateOfQuarter, endDateOfQuarter)
              form.setFieldsValue({
                [element.columnName]: [
                  moment(new Date(startDateOfQuarter), dateFormat),
                  moment(new Date(), dateFormat),
                ],
              })
              break
            case "thisYear":
              if (userCurrency === "INR") {
                const today = new Date()
                const fiscalYearFirstDayForYearToDate = dateConvertor(new Date(today.getFullYear(), 3, 1))
                formattedDateForButton(fiscalYearFirstDayForYearToDate, dateConvertor(today))
                form.setFieldsValue({
                  [element.columnName]: [
                    moment(new Date(fiscalYearFirstDayForYearToDate), dateFormat),
                    moment(new Date(), dateFormat),
                  ],
                })
              } else {
                const currentDate = new Date()
                const theFirst = dateConvertor(new Date(currentDate.getFullYear(), 0, 1))
                form.setFieldsValue({
                  [element.columnName]: [moment(new Date(theFirst), dateFormat), moment(new Date(), dateFormat)],
                })
                formattedDateForButton(theFirst, currentDate)
              }
              break
            case "nodate":
              const monthsNoDate = new Date()
              const monthsNoYear = monthsNoDate.getFullYear()
              const monthNoData = monthsNoDate.getMonth()
              const firstDayOfNoMonth = dateConvertor(new Date(monthsNoYear, monthNoData, 1))
              const lastDayOfNoMonth = dateConvertor(new Date(monthsNoYear, monthNoData + 1, 0))
              formattedDateForButton(firstDayOfNoMonth, lastDayOfNoMonth)
              form.setFieldsValue({
                [element.columnName]: [
                  moment(new Date(firstDayOfNoMonth), dateFormat),
                  moment(new Date(lastDayOfNoMonth), dateFormat),
                ],
              })
              break
            default:
              const monthsDate = new Date()
              const monthsYear = monthsDate.getFullYear()
              const monthData = monthsDate.getMonth()
              const firstDayOfMonth = dateConvertor(new Date(monthsYear, monthData, 1))
              const lastDayOfMonth = dateConvertor(new Date(monthsYear, monthData + 1, 0))
              formattedDateForButton(firstDayOfMonth, lastDayOfMonth)
              form.setFieldsValue({
                [element.columnName]: [
                  moment(new Date(firstDayOfMonth), dateFormat),
                  moment(new Date(lastDayOfMonth), dateFormat),
                ],
              })
              break
          }
        }
      }
      if (element.type === "Date" || element.type === "DateTime") {
        dateTypeValue = element.type
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ]
        setDateRangeColumnName({ type: element.type, value: element.columnName })
        setDefaultValueExpression(element.defaultValueExpression)
        const { defaultValueExpression } = element
        if (!defaultValueExpression) {
          const startDate = new Date()
          const startDateDay = startDate.getDate()
          const startDateMonth = monthNames[startDate.getMonth()]
          const startDateYear = startDate.getFullYear()
          const formattedStartDate = `${startDateDay}-${startDateMonth}-${startDateYear}`
          setButtonName(formattedStartDate)
          form.setFieldsValue({ [element.columnName]: moment(new Date(), dateFormat) })
        } else {
          switch (element.defaultValueExpression) {
            case "today":
              const startDate = new Date()
              const startDateDay = startDate.getDate()
              const startDateMonth = monthNames[startDate.getMonth()]
              const startDateYear = startDate.getFullYear()
              const formattedStartDate = `${startDateDay}-${startDateMonth}-${startDateYear}`
              form.setFieldsValue({ [element.columnName]: moment(new Date(), dateFormat) })
              setButtonName(formattedStartDate)
              break
            case "yesterday":
              const monthNamesYesterday = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ]
              const yesterdaysDate = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
              const startDateDayYesterday = yesterdaysDate.getDate()
              const startDateMonthYesterday = monthNamesYesterday[yesterdaysDate.getMonth()]
              const startDateYearYesterday = yesterdaysDate.getFullYear()
              const formattedStartDateYesterday = `${startDateDayYesterday}-${startDateMonthYesterday}-${startDateYearYesterday}`
              form.setFieldsValue({ [element.columnName]: moment(new Date(yesterdaysDate), dateFormat) })
              setButtonName(formattedStartDateYesterday)
              break
            default:
              const startDateDefault = new Date()
              const startDateDayDefault = startDateDefault.getDate()
              const startDateMonthDefault = monthNames[startDateDefault.getMonth()]
              const startDateYearDefault = startDateDefault.getFullYear()
              const formattedStartDateDefault = `${startDateDayDefault}-${startDateMonthDefault}-${startDateYearDefault}`
              setButtonName(formattedStartDateDefault)
              form.setFieldsValue({ [element.columnName]: moment(new Date(), dateFormat) })
          }
        }
      }
      if (element.type === "String" && element.isForPrompting === "Y") {
        const { defaultValueExpression } = element
        form.setFieldsValue({ [element.columnName]: defaultValueExpression })
      }
    }
    console.log("enableschedulereport", enableschedulereport)
    if (enableschedulereport === "N") {
      console.log("---if")
      setScheduledReportFlag(true)
    } else {
      console.log("---if")
      setScheduledReportFlag(false)
    }

    setReportFilters(visibleFiltersArr)
    setReportFiltersForDatePopup(reportFilters)
    setReportDateOptionsFlag(true)
  }, [reportId, reportData])

  useEffect(() => {
    if (isQuerySelectionAutoRun && reportSelector) {
      executeData()
      setIsQuerySelectionAutoRun(false)
    }
  }, [reportSelector, isQuerySelectionAutoRun])

  const handleQueryChange = (value) => {
    setReportSelector(value)
    if (showGridData) {
      setIsQuerySelectionAutoRun(true)
    }
  }

  const rangeDateChange = (date, dateString) => {
    console.log("date", date)
    console.log("dateString", dateString)
    if (!date || !date[0] || !date[1]) {
      return
    }
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ]
    // Use toDate() to properly extract the date from Moment object
    const startDate = date[0].toDate()
    const startDateDay = startDate.getDate()
    console.log("startDateDay", startDateDay)
    const startDateMonth = monthNames[startDate.getMonth()]
    console.log("startDateMonth", startDateMonth)
    const startDateYear = startDate.getFullYear()
    console.log("startDateYear", startDateYear)
    const endDate = date[1].toDate()
    const endDateDay = endDate.getDate()
    console.log("endDateDay", endDateDay)
    const endDateMonth = monthNames[endDate.getMonth()]
    console.log("endDateMonth", endDateMonth)
    const endDateYear = endDate.getFullYear()
    console.log("endDateYear", endDateYear)
    const formattedStartDate = `${startDateMonth} ${startDateDay}`
    const formattedEndDate = `${endDateMonth} ${endDateDay}`
    console.log("formattedStartDate", formattedStartDate)
    console.log("formattedEndDate", formattedEndDate)
    const fullFormattedDate = `${formattedStartDate}-${formattedEndDate}, ${endDateYear}`
    setButtonName(fullFormattedDate)
  }

  const onDateChange = (date, dateString) => {
    console.log("date", date)
    console.log("dateString", dateString)
    if (!date) {
      return
    }
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ]
    // Use toDate() to properly extract the date from Moment object
    const startDate = date.toDate()
    const startDateDay = startDate.getDate()
    const startDateMonth = monthNames[startDate.getMonth()]
    const startDateYear = startDate.getFullYear()
    const formattedStartDate = `${startDateDay}-${startDateMonth}-${startDateYear}`
    setButtonName(formattedStartDate)
  }

  const focusedRangePicker = () => {
    form.resetFields(["_dateRange"])
  }

  const focusedDatePicker = () => {
    form.resetFields(["_dateRange"])
  }

  const onSearchFunction = async (value) => {
    const getReportData = await getComboFillForReportIdAndValue(multiSelectorDropdownId, value, reportId)
    const reportsGridArray2 = []
    let dataArray3
    for (let index = 0; index < getReportData?.length; index++) {
      if (typeof getReportData[index] === "string") {
        dataArray3 = JSON.parse(getReportData[index])
        reportsGridArray2.push(dataArray3)
      } else {
        dataArray3 = getReportData[index]
        reportsGridArray2.push(dataArray3)
      }
    }
    setDropdownDetails([...reportsGridArray2])
  }

  const handleCancel = () => {
    setPopupForDrillDown(false)
  }

  const handleFilterDropdownVisibleChange = (flag) => {
    setFilterDropdownVisible(flag)
  }

  const getData = (event) => {
    onSearchFunction(event)
  }

  const onDropDownSelectForListReference = (values) => {
    setListReferenceDetails([...values])
  };

  const debounce = (fn, d) => {
    let timer
    return function () {
      const args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        getData.apply(this, arguments)
      }, d)
    }
  }

  const searchDropdownRecords = debounce(getData, 300)

  const onDropDownSelect = async (id, dependentId) => {
    const formdata = form.getFieldValue()
    if (!dependentId) {
      setMultiSelectorDropdownId(id)
      setDropdownDetails([])
      const getReportData = await getComboFillForReportOnlyId(id, undefined, reportId)
      const reportsGridArray = []
      let dataArray2
      for (let index = 0; index < getReportData.length; index++) {
        if (typeof getReportData[index] === "string") {
          dataArray2 = JSON.parse(getReportData[index])
          reportsGridArray.push(dataArray2)
        } else {
          dataArray2 = getReportData[index]
          reportsGridArray.push(dataArray2)
        }
      }
      setDropdownDetails([...reportsGridArray])
    } else {
      let columnNameId = null
      for (let index = 0; index < reportFilters.length; index++) {
        const elementDependentId = reportFilters[index].id
        if (elementDependentId === dependentId) {
          columnNameId = reportFilters[index].columnName
        }
      }
      const dependentValueId = formdata[columnNameId]
      setMultiSelectorDropdownId(id)
      setDropdownDetails([])
      const getReportData = await getComboFillForReportOnlyId(id, dependentValueId, reportId)
      const reportsGridArray = []
      let dataArray2
      if (getReportData) {
        for (let index = 0; index < getReportData.length; index++) {
          if (typeof getReportData[index] === "string") {
            dataArray2 = JSON.parse(getReportData[index])
            reportsGridArray.push(dataArray2)
          } else {
            dataArray2 = getReportData[index]
            reportsGridArray.push(dataArray2)
          }
        }
        setDropdownDetails([...reportsGridArray])
      }
    }
  }

  const downloadFile = (fileName) => {
    console.log(fileName)
    const extractedFileName = fileName?.split("/").pop()
    try {
      Axios({
        url: `${fileName}`,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement("a")
        link.setAttribute("id", "downloadlink")
        link.href = fileURL
        link.setAttribute("download", `${extractedFileName}`)
        link.click()
      })
    } catch (error) {
      const { message } = JSON.parse(JSON.stringify(error))
      if (
        message === "Network error: Unexpected token < in JSON at position 0" ||
        message === "Request failed with status code 401"
      ) {
        generateToken()
      } else {
        return Promise.reject(error)
      }
    }
  }

  const downloadData = async (type, id) => {
    try {
      await form.validateFields()
      setLoading(true)
      const inputJson = await form.getFieldsValue(true)
      const jsonToSend = JSON.stringify(inputJson).replace(/"/g, '\\"')
      const { access_token } = getOAuthHeaders()
      const downloadMutation = {
        query: `query {
                    downloadAnalyticsReport(reportId: "${reportId}", queryId: ${id ? `"${id}"` : null}, reportParam:"${jsonToSend}", exportType:"${type}", isBatch: "N") {title, message, downloadURL}
                }`,
      }

      const headers = {
        "Content-Type": "application/json",
        Authorization: `bearer ${access_token}`,
        appId: appId,
      }
      const response = await Axios.post(genericUrl, downloadMutation, { headers: headers })
      const responseFromServer = response.data.data.downloadAnalyticsReport
      if (responseFromServer.title === "Success") {
        console.log(responseFromServer)
        const fileName = responseFromServer.downloadURL
        downloadFile(fileName)
        setLoading(false)
      } else {
        message.error(responseFromServer.message)
        setLoading(false)
      }
    } catch (error) {
      const { message } = JSON.parse(JSON.stringify(error))
      if (
        message === "Network error: Unexpected token < in JSON at position 0" ||
        message === "Request failed with status code 401"
      ) {
        generateToken()
      } else {
        return Promise.reject(error)
      }
    }
  }



  // Helper function to get display name for columns
  const getDisplayName = (field) => {
    const columnConfig = headerData?.find((col) => col.dataIndex === field)
    return columnConfig?.title?.props?.children || field
  }

  // Image detection utility function
  const isImageUrl = (url) => {
    if (!url || typeof url !== "string") return false
    if (url.startsWith("data:image/")) return true
    if (url.startsWith("blob:")) return true
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp|svg|ico|tiff)(\?.*)?$/i
    return imageExtensions.test(url)
  }

  // Check if data contains image (JSX object or URL string)
  const isImageData = (data) => {
    if (typeof data === "object" && data !== null && data.props && data.props.src) {
      return isImageUrl(data.props.src)
    }
    if (typeof data === "string") {
      return isImageUrl(data)
    }
    return false
  }

  // Extract image URL from React JSX object or regular string
  const extractImageUrl = (imageData) => {
    if (!imageData) return null
    if (typeof imageData === "object" && imageData.props && imageData.props.src) {
      return imageData.props.src
    }
    if (typeof imageData === "string" && isImageUrl(imageData)) {
      return imageData
    }
    return null
  }

  // Convert image URL to base64 with CORS handling
  const imageToBase64 = async (url) => {
    try {
      console.log("Converting image to base64:", url)
      const response = await fetch(url, {
        mode: "cors",
        method: "GET",
        headers: {
          Accept: "image/*",
        },
      })

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }

      const blob = await response.blob()
      if (blob.size === 0) {
        throw new Error("Empty image data received")
      }

      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          const result = reader.result
          if (result && typeof result === "string") {
            console.log("Successfully converted to base64, length:", result.length)
            resolve(result)
          } else {
            reject(new Error("Failed to convert to base64"))
          }
        }
        reader.onerror = () => reject(new Error("FileReader error"))
        reader.readAsDataURL(blob)
      })
    } catch (error) {
      console.error("Primary image conversion failed:", error)
      try {
        console.log("Trying canvas fallback...")
        return await new Promise((resolve, reject) => {
          const img = new Image()
          img.crossOrigin = "anonymous"
          img.onload = () => {
            try {
              const canvas = document.createElement("canvas")
              const ctx = canvas.getContext("2d")
              canvas.width = Math.min(img.width, 200)
              canvas.height = Math.min(img.height, 200)
              ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
              const dataURL = canvas.toDataURL("image/jpeg", 0.8)
              console.log("Canvas conversion successful")
              resolve(dataURL)
            } catch (canvasError) {
              console.error("Canvas conversion failed:", canvasError)
              reject(canvasError)
            }
          }
          img.onerror = () => {
            console.error("Image load failed")
            reject(new Error("Failed to load image for canvas conversion"))
          }
          img.src = url
        })
      } catch (fallbackError) {
        console.error("All image conversion methods failed:", fallbackError)
        return null
      }
    }
  }

  // Pivot export function to Excel with image support
  const exportPivotToExcel = async () => {
    if (!pivotExportData || pivotExportData.length === 0) {
      message.error("No pivot data to export")
      return
    }

    try {
      const workbook = new ExcelJS.Workbook()
      const ws = workbook.addWorksheet("Pivot Table")

      // Get pivot config to check for formula columns
      const pivotConfig = reportData.analyticsReportConfiguration.displayConfiguration?.pivotConfig
      const formulaColumns = pivotConfig?.formulaColumns || []
      const hasFormulaColumns = formulaColumns.length > 0

      console.log("pivotExportData:", pivotExportData)
      console.log("hasFormulaColumns:", hasFormulaColumns)

      // Hierarchical export for all pivot tables
      const valueFields = pivotConfig?.values || []
      const rowFields = pivotConfig?.rows || []
      const columnValues = Array.from(
        new Set(
          gridData[0]?.data
            ?.map((row) => pivotConfig.columns.map((col) => row[col]).join("|"))
            .filter((val) => val && val !== ""),
        ),
      ).sort()
      const imagePositions = []

      // First header row - Product categories with merged cells
      const mainHeaderRow = []
      rowFields.forEach((field) => {
        mainHeaderRow.push(getDisplayName(field))
      })
      columnValues.forEach((columnValue) => {
        const displayValue = columnValue.split("|").join(" - ")
        const totalSubColumns = valueFields.length + formulaColumns.length
        mainHeaderRow.push(displayValue)
        for (let i = 1; i < totalSubColumns; i++) {
          mainHeaderRow.push("")
        }
      })
      const totalSubColumnsTotal = valueFields.length + formulaColumns.length
      mainHeaderRow.push("Total")
      for (let i = 1; i < totalSubColumnsTotal; i++) {
        mainHeaderRow.push("")
      }
      const excelMainHeaderRow = ws.addRow(mainHeaderRow)
      excelMainHeaderRow.font = { bold: true }
      excelMainHeaderRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE0E0E0" },
      }

      // Second header row - Sub-columns
      const subHeaderRow = []
      rowFields.forEach(() => {
        subHeaderRow.push("")
      })
      columnValues.forEach(() => {
        valueFields.forEach((valueField) => {
          subHeaderRow.push(getDisplayName(valueField))
        })
        formulaColumns.forEach((formula) => {
          subHeaderRow.push(formula.displayName)
        })
      })
      valueFields.forEach((valueField) => {
        subHeaderRow.push(getDisplayName(valueField))
      })
      formulaColumns.forEach((formula) => {
        subHeaderRow.push(formula.displayName)
      })
      const excelSubHeaderRow = ws.addRow(subHeaderRow)
      excelSubHeaderRow.font = { bold: true }
      excelSubHeaderRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE0E0E0" },
      }

      // Data rows
      let currentRowIndex = 3
      const dataRows = pivotExportData.slice(1)
      dataRows.forEach((row) => {
        const excelRow = []
        let colIndex = 1
        rowFields.forEach((field) => {
          const rowValue = row[field]
          excelRow.push(typeof rowValue === "string" ? rowValue.trim() : rowValue || "")
          colIndex++
        })
        columnValues.forEach((columnValue) => {
          valueFields.forEach((valueField) => {
            const key = `${columnValue}_${valueField}`
            const value = row[key]
            if (isImageData(value)) {
              const imageUrl = extractImageUrl(value)
              if (imageUrl) {
                excelRow.push("[IMAGE]")
                imagePositions.push({ url: imageUrl, row: currentRowIndex, col: colIndex })
              } else {
                excelRow.push("[NO IMAGE]")
              }
            } else {
              excelRow.push(typeof value === "number" ? value : (typeof value === "string" ? value.trim() : value || ""))
            }
            colIndex++
          })
          formulaColumns.forEach((formula) => {
            const key = `${columnValue}_${formula.name}`
            const value = row[key]
            if (typeof value === "number") {
              const formattedValue = formula.format === "percentage" ? `${value.toFixed(3)}%` : value.toFixed(2)
              excelRow.push(formattedValue)
            } else {
              excelRow.push(typeof value === "string" ? value.trim() : value || "")
            }
            colIndex++
          })
        })
        valueFields.forEach((valueField) => {
          const key = `total_${valueField}`
          const value = row[key]
          if (isImageData(value)) {
            const imageUrl = extractImageUrl(value)
            if (imageUrl) {
              excelRow.push("[IMAGE]")
              imagePositions.push({ url: imageUrl, row: currentRowIndex, col: colIndex })
            } else {
              excelRow.push("[NO IMAGE]")
            }
          } else {
            excelRow.push(typeof value === "number" ? value : (typeof value === "string" ? value.trim() : value || ""))
          }
          colIndex++
        })
        formulaColumns.forEach((formula) => {
          const key = `total_${formula.name}`
          const value = row[key]
          if (typeof value === "number") {
            const formattedValue = formula.format === "percentage" ? `${value.toFixed(3)}%` : value.toFixed(2)
            excelRow.push(formattedValue)
          } else {
            excelRow.push(typeof value === "string" ? value.trim() : value || "")
          }
          colIndex++
        })
        const addedRow = ws.addRow(excelRow)
        currentRowIndex++
      })

      // Set up merges for main headers
      let colIndexMerge = rowFields.length + 1
      columnValues.forEach(() => {
        const totalSubColumns = valueFields.length + formulaColumns.length
        if (totalSubColumns > 1) {
          ws.mergeCells(1, colIndexMerge, 1, colIndexMerge + totalSubColumns - 1)
        }
        colIndexMerge += totalSubColumns
      })
      if (totalSubColumnsTotal > 1) {
        ws.mergeCells(1, colIndexMerge, 1, colIndexMerge + totalSubColumnsTotal - 1)
      }

      // Auto-size columns
      const colWidths = subHeaderRow.map((header, index) => {
        let maxColumnLength = header?.toString().length || 0;
        dataRows.forEach((row) => {
          // calculate based on what was put in excelRow actually:
          // it's tricky to map accurately here because row is original pivot row
          // Let's just use a default length or simplified mapping for widths
        })
        return { width: Math.min(Math.max(maxColumnLength + 5, 10), 30) }
      })
      ws.columns = colWidths

      // Process images
      if (imagePositions.length > 0) {
        message.info(`Processing ${imagePositions.length} images for Excel...`)
        let successCount = 0
        for (let i = 0; i < imagePositions.length; i++) {
          const imageInfo = imagePositions[i]
          try {
            const base64Data = await imageToBase64(imageInfo.url)
            if (base64Data) {
              const base64Image = base64Data.split(",")[1]
              const extension = base64Data.includes("data:image/png") ? "png" : "jpeg"
              const imageId = workbook.addImage({
                base64: base64Image,
                extension: extension,
              })
              ws.addImage(imageId, {
                tl: { col: imageInfo.col - 1, row: imageInfo.row - 1 },
                ext: { width: 60, height: 40 },
                editAs: "oneCell",
              })
              ws.getCell(imageInfo.row, imageInfo.col).value = ""
              successCount++
              console.log(`Successfully added Excel image ${i + 1}`)
            }
          } catch (error) {
            console.error(`Failed to process Excel image ${i + 1}:`, error)
          }
        }
        message.info(`${successCount}/${imagePositions.length} images successfully embedded`)
      }

      // Generate filename with timestamp
      const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, "-")
      const filename = `${reportName}-pivot-table-${timestamp}.xlsx`
      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

      message.success("Excel file exported successfully!")
    } catch (error) {
      console.error("Error exporting to Excel:", error)
      message.error("Failed to export Excel file")
    }
  }

  // Pivot export function to PDF with image support
  const exportPivotToPDF = async () => {
    if (!pivotExportData || pivotExportData.length === 0) {
      message.error("No pivot data to export")
      return
    }

    try {
      const pivotConfig = reportData.analyticsReportConfiguration.displayConfiguration?.pivotConfig
      const formulaColumns = pivotConfig?.formulaColumns || []
      const hasFormulaColumns = formulaColumns.length > 0

      // ─── Sizing constants (all in mm) ─────────────────────────────────────
      const MARGIN = 10
      const ROW_COL_WIDTH = 38   // width for row-label columns
      const VAL_COL_WIDTH = 28   // width for value / formula columns
      const PAGE_HEIGHT = 210    // A4 landscape height
      const HEADER_SPACE = 35

      // Build a jsPDF whose width exactly fits all columns
      const buildDoc = (totalCols, rowFieldCount) => {
        const valueCols = totalCols - rowFieldCount
        const tableWidth = rowFieldCount * ROW_COL_WIDTH + valueCols * VAL_COL_WIDTH
        const pageWidth = Math.max(tableWidth + MARGIN * 2, 297)
        const doc = new jsPDF({ orientation: "l", unit: "mm", format: [PAGE_HEIGHT, pageWidth] })
        return { doc, pageWidth }
      }

      // Build uniform column styles with explicit cellWidth
      const buildColumnStyles = (count, rowFieldCount) => {
        const styles = {}
        for (let i = 0; i < count; i++) {
          styles[i] = {
            cellWidth: i < rowFieldCount ? ROW_COL_WIDTH : VAL_COL_WIDTH,
            halign: i < rowFieldCount ? "left" : "right",
            overflow: "linebreak",
          }
        }
        return styles
      }

      if (!hasFormulaColumns) {
        const headers = Object.keys(pivotExportData[0])
        const rowFieldCount = pivotConfig?.rows?.length || 1
        const { doc, pageWidth } = buildDoc(headers.length, rowFieldCount)

        doc.setFontSize(14)
        doc.text(`${reportName} - Pivot Table Report`, MARGIN, 15)
        doc.setFontSize(9)
        doc.text(`Generated on: ${new Date().toLocaleString()}`, MARGIN, 23)

        const dataRows = pivotExportData.slice(1)
        const tableData = []
        const imageMap = new Map()

        dataRows.forEach((row, rowIndex) => {
          const tableRow = []
          headers.forEach((header, colIndex) => {
            const cellValue = row[header]
            if (isImageData(cellValue)) {
              const imageUrl = extractImageUrl(cellValue)
              tableRow.push(imageUrl ? " " : "[NO IMG]")
              if (imageUrl) imageMap.set(`${rowIndex}_${colIndex}`, imageUrl)
            } else {
              tableRow.push(typeof cellValue === "number" ? cellValue.toLocaleString() : (typeof cellValue === "string" ? cellValue.trim() : cellValue || ""))
            }
          })
          tableData.push(tableRow)
        })

        doc.autoTable({
          head: [headers.map((header) => pivotExportData[0][header])],
          body: tableData,
          startY: HEADER_SPACE,
          tableWidth: pageWidth - MARGIN * 2,
          margin: { left: MARGIN, right: MARGIN },
          styles: { fontSize: 7, cellPadding: 2, minCellHeight: 10, overflow: "linebreak" },
          headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255], fontStyle: "bold", fontSize: 7 },
          alternateRowStyles: { fillColor: [245, 250, 255] },
          columnStyles: buildColumnStyles(headers.length, rowFieldCount),
          didDrawPage: (data) => {
            doc.setFontSize(8)
            doc.text(
              `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
              MARGIN,
              doc.internal.pageSize.height - 6,
            )
          },
        })

        if (imageMap.size > 0) {
          message.info(`Processing ${imageMap.size} images for PDF...`)
          let successCount = 0
          for (const [position, imageUrl] of imageMap.entries()) {
            try {
              const base64Data = await imageToBase64(imageUrl)
              if (base64Data) {
                const [rowIdx, colIdx] = position.split("_").map(Number)
                doc.addImage(base64Data, "JPEG", MARGIN + colIdx * VAL_COL_WIDTH + 2, HEADER_SPACE + rowIdx * 10 + 2, VAL_COL_WIDTH - 4, 8)
                successCount++
              }
            } catch (error) {
              console.error(`Failed to add PDF image at position ${position}:`, error)
            }
          }
          message.info(`${successCount}/${imageMap.size} images added to PDF`)
        }

        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, "-")
        doc.save(`${reportName}-pivot-table-${timestamp}.pdf`)
        message.success("PDF file exported successfully!")
        return
      }

      // ── Branch: with formula columns ─────────────────────────────────────
      const valueFields = pivotConfig?.values || []
      const rowFields = pivotConfig?.rows || []
      const columnValues = Array.from(
        new Set(
          gridData[0]?.data
            ?.map((row) => pivotConfig.columns.map((col) => row[col]).join("|"))
            .filter((val) => val && val !== ""),
        ),
      ).sort()

      const totalSubColumns = valueFields.length + formulaColumns.length
      const totalCols = rowFields.length + columnValues.length * totalSubColumns + totalSubColumns
      const { doc, pageWidth } = buildDoc(totalCols, rowFields.length)

      doc.setFontSize(14)
      doc.text(`${reportName} - Pivot Table Report`, MARGIN, 15)
      doc.setFontSize(9)
      doc.text(`Generated on: ${new Date().toLocaleString()}`, MARGIN, 23)

      const mainHeaders = []
      rowFields.forEach((field) => mainHeaders.push(getDisplayName(field)))
      const subHeaders = []
      rowFields.forEach(() => subHeaders.push(""))

      columnValues.forEach((columnValue) => {
        const displayValue = columnValue.split("|").join(" - ")
        mainHeaders.push(displayValue)
        for (let i = 1; i < totalSubColumns; i++) mainHeaders.push("")
        valueFields.forEach((vf) => subHeaders.push(getDisplayName(vf)))
        formulaColumns.forEach((f) => subHeaders.push(f.displayName))
      })
      mainHeaders.push("Total")
      for (let i = 1; i < totalSubColumns; i++) mainHeaders.push("")
      valueFields.forEach((vf) => subHeaders.push(getDisplayName(vf)))
      formulaColumns.forEach((f) => subHeaders.push(f.displayName))

      const tableData = []
      const imageMap = new Map()
      const dataRows = pivotExportData.slice(1)

      dataRows.forEach((row, rowIndex) => {
        const pdfRow = []
        let colIndex = 0
        rowFields.forEach((field) => { pdfRow.push(row[field] || ""); colIndex++ })
        columnValues.forEach((columnValue) => {
          valueFields.forEach((valueField) => {
            const key = `${columnValue}_${valueField}`
            const value = row[key]
            if (isImageData(value)) {
              const imageUrl = extractImageUrl(value)
              pdfRow.push(imageUrl ? " " : "[NO IMG]")
              if (imageUrl) imageMap.set(`${rowIndex}_${colIndex}`, imageUrl)
            } else {
              pdfRow.push(typeof value === "number" ? value.toLocaleString() : (typeof value === "string" ? value.trim() : value || ""))
            }
            colIndex++
          })
          formulaColumns.forEach((formula) => {
            const key = `${columnValue}_${formula.name}`
            const value = row[key]
            if (typeof value === "number") {
              const formattedValue = formula.format === "percentage" ? `${value.toFixed(2)}%` : value.toLocaleString()
              pdfRow.push(formattedValue)
            } else {
              pdfRow.push(typeof value === "string" ? value.trim() : value || "")
            }
            colIndex++
          })
        })
        valueFields.forEach((valueField) => {
          const key = `total_${valueField}`
          const value = row[key]
          if (isImageData(value)) {
            const imageUrl = extractImageUrl(value)
            pdfRow.push(imageUrl ? " " : "[NO IMG]")
            if (imageUrl) imageMap.set(`${rowIndex}_${colIndex}`, imageUrl)
          } else {
            pdfRow.push(typeof value === "number" ? value.toLocaleString() : (typeof value === "string" ? value.trim() : value || ""))
          }
          colIndex++
        })
        formulaColumns.forEach((formula) => {
          const key = `total_${formula.name}`
          const value = row[key]
          if (typeof value === "number") {
            const formattedValue = formula.format === "percentage" ? `${value.toFixed(2)}%` : value.toLocaleString()
            pdfRow.push(formattedValue)
          } else {
            pdfRow.push(typeof value === "string" ? value.trim() : value || "")
          }
          colIndex++
        })
        tableData.push(pdfRow)
      })

      doc.autoTable({
        head: [mainHeaders, subHeaders],
        body: tableData,
        startY: HEADER_SPACE,
        tableWidth: pageWidth - MARGIN * 2,
        margin: { left: MARGIN, right: MARGIN },
        styles: { fontSize: 6, cellPadding: 1.5, minCellHeight: 10, overflow: "linebreak" },
        headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255], fontStyle: "bold", fontSize: 6 },
        alternateRowStyles: { fillColor: [245, 250, 255] },
        columnStyles: buildColumnStyles(subHeaders.length, rowFields.length),
        didDrawPage: (data) => {
          doc.setFontSize(8)
          doc.text(
            `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
            MARGIN,
            doc.internal.pageSize.height - 6,
          )
        },
      })

      if (imageMap.size > 0) {
        message.info(`Processing ${imageMap.size} images for PDF...`)
        let successCount = 0
        for (const [position, imageUrl] of imageMap.entries()) {
          try {
            const base64Data = await imageToBase64(imageUrl)
            if (base64Data) {
              const [rowIdx, colIdx] = position.split("_").map(Number)
              doc.addImage(base64Data, "JPEG", MARGIN + colIdx * VAL_COL_WIDTH + 2, HEADER_SPACE + rowIdx * 10 + 2, VAL_COL_WIDTH - 4, 8)
              successCount++
            }
          } catch (error) {
            console.error(`Failed to add PDF image at position ${position}:`, error)
          }
        }
        message.info(`${successCount}/${imageMap.size} images added to PDF`)
      }

      const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, "-")
      doc.save(`${reportName}-pivot-table-${timestamp}.pdf`)
      message.success("PDF file exported successfully!")
    } catch (error) {
      console.error("Error exporting to PDF:", error)
      message.error("Failed to export PDF file")
    }
  }



  const handlePivotExport = (exportType) => {
    if (exportType === "Excel") {
      exportPivotToExcel()
    } else if (exportType === "PDF") {
      exportPivotToPDF()
    }
  }

  // ── DrillDown export helpers ──────────────────────────────────────────────
  // title is stored as <div className="dragHandler">{displayName}</div>, extract plain string
  const getColTitle = (h) => {
    if (typeof h.title === "string") return h.title
    if (h.title?.props?.children) return String(h.title.props.children)
    return h.dataIndex || ""
  }

  const getDrillDownExportData = () => {
    const queryConfig = reportData.analyticsReportConfiguration.queryConfiguration.find(
      (q) => q.isDrilldownQuery !== "Y"
    )
    const headers = headerData[0]?.headers || []
    const rows = gridData[0]?.data || []
    const configLevels = (queryConfig?.groupingConfiguration?.levels || []).slice().sort((a, b) => a.level - b.level)
    const levelFields = configLevels.map((l) => l.fieldName)
    const fallbackField = queryConfig?.columnGroups?.[0]?.columns?.[0] || null
    const allLevelFields = levelFields.length > 0 ? levelFields : fallbackField ? [fallbackField] : []
    const activeLevel = drillDownSelectedLevel || allLevelFields.length || 1
    const effectiveLevelFields = allLevelFields.slice(0, activeLevel)
    const showGrandTotal = queryConfig?.groupingConfiguration?.showGrandTotal !== false
    // Mirror DrillDownTable: hide intermediate group-field columns (only col 0 remains visible for keys)
    const hiddenGroupFields = new Set(effectiveLevelFields.slice(1))
    const exportHeaders = headers.filter((h) => !hiddenGroupFields.has(h.dataIndex))
    const numericDataIndexes = exportHeaders.filter((h) => h.type === "Amount" || h.type === "Numeric").map((h) => h.dataIndex)

    // ── Build nested group tree (mirrors DrillDownTable logic) ────────────
    const buildGroupTree = (treeRows, fields, depth) => {
      if (!fields.length || !treeRows.length) return treeRows
      const field = fields[0]
      const rest = fields.slice(1)
      const map = new Map()
      treeRows.forEach((row) => {
        const k = row[field] != null ? String(row[field]).trim() : ""
        if (!map.has(k)) map.set(k, [])
        map.get(k).push(row)
      })
      const groups = []
      map.forEach((groupRows, key) => {
        const subtotals = {}
        numericDataIndexes.forEach((f) => {
          subtotals[f] = groupRows.reduce((s, r) => s + parseFloat(r[f] || 0), 0)
        })
        groups.push({
          field,
          key,
          depth,
          subtotals,
          levelConfig: configLevels[depth] || null,
          isLeaf: rest.length === 0,
          children: rest.length > 0 ? buildGroupTree(groupRows, rest, depth + 1) : groupRows,
        })
      })
      return groups
    }

    const groupTree = effectiveLevelFields.length > 0 ? buildGroupTree(rows, effectiveLevelFields, 0) : null
    // true only when showing all levels — leaf groups render as plain rows
    // false when a reduced level is selected — leaf groups render as bold group headers
    const isFullDepth = activeLevel >= allLevelFields.length

    // ── Flatten tree into a list of { type, depth, group?, row? } ─────────
    // Mirrors renderGroups logic in DrillDownTable exactly:
    //   non-leaf  → "group" (bold header)
    //   leaf + isFullDepth → "leaf" (plain row, no children)
    //   leaf + !isFullDepth → "group" (bold summary row, level dropdown view)
    const flatRows = []
    const flatten = (groups) => {
      groups.forEach((group) => {
        if (!group.isLeaf) {
          flatRows.push({ type: "group", depth: group.depth, group })
          flatten(group.children)
        } else if (isFullDepth) {
          flatRows.push({ type: "leaf", depth: group.depth, group })
        } else {
          flatRows.push({ type: "group", depth: group.depth, group })
        }
      })
    }
    if (groupTree) flatten(groupTree)
    else rows.forEach((row) => flatRows.push({ type: "detail", depth: 0, row }))

    // ── Grand totals ───────────────────────────────────────────────────────
    const grandTotals = {}
    numericDataIndexes.forEach((f) => {
      grandTotals[f] = rows.reduce((s, r) => s + parseFloat(r[f] || 0), 0)
    })

    return { headers: exportHeaders, flatRows, grandTotals, effectiveLevelFields, numericDataIndexes, showGrandTotal }
  }

  // Background ARGB per depth level for Excel
  const excelGroupFill = ["FFD6DCE4", "FFEEF2F7", "FFF5F7FA"]

  // Background RGB per depth level for PDF
  const pdfGroupFill = [[214, 220, 228], [238, 242, 247], [245, 247, 250]]

  const exportDrillDownToExcel = async () => {
    const { headers, flatRows, grandTotals, effectiveLevelFields, numericDataIndexes, showGrandTotal } = getDrillDownExportData()
    if (!headers.length) { message.error("No data to export"); return }

    const userPrefs = JSON.parse(localStorage.getItem("userPreferences"))
    const decimals = userPrefs?.decimalPlaces || 2
    const numFmtStr = `#,##0.${"0".repeat(decimals)}`

    const workbook = new ExcelJS.Workbook()
    const ws = workbook.addWorksheet("DrillDown Report")

    // ── Column header row ──────────────────────────────────────────────────
    const headerRow = ws.addRow(headers.map((h) => getColTitle(h)))
    headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } }
    headerRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF4472C4" } }
    headerRow.eachCell((cell, ci) => {
      const col = headers[ci - 1]
      cell.alignment = { horizontal: col?.type === "Amount" || col?.type === "Numeric" ? "right" : "left" }
    })

    // ── Data rows ──────────────────────────────────────────────────────────
    flatRows.forEach(({ type, depth, group, row }) => {
      if (type === "group") {
        // Key always goes in col 0 (mirrors DrillDownTable: all group keys in first column)
        const showSubtotal = group.levelConfig?.showSubtotal !== false
        const rowData = headers.map((h, i) => {
          if (i === 0) return group.key || ""
          if (showSubtotal && numericDataIndexes.includes(h.dataIndex)) return parseFloat(group.subtotals[h.dataIndex] || 0)
          return ""
        })
        const excelRow = ws.addRow(rowData)
        excelRow.font = { bold: true }
        excelRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: excelGroupFill[depth] || "FFF5F5F5" } }
        excelRow.eachCell((cell, ci) => {
          const col = headers[ci - 1]
          const isNumeric = col?.type === "Amount" || col?.type === "Numeric"
          cell.alignment = { horizontal: isNumeric ? "right" : "left", indent: !isNumeric && ci === 1 ? depth : 0 }
          if (isNumeric) cell.numFmt = numFmtStr
        })
      } else if (type === "leaf") {
        // Deepest level: plain row — key in col 0, subtotals in numeric cols
        const showSubtotal = group.levelConfig?.showSubtotal !== false
        const rowData = headers.map((h, i) => {
          if (i === 0) return group.key || ""
          if (showSubtotal && numericDataIndexes.includes(h.dataIndex)) return parseFloat(group.subtotals[h.dataIndex] || 0)
          return ""
        })
        const excelRow = ws.addRow(rowData)
        excelRow.font = { bold: false }
        excelRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFFFF" } }
        excelRow.eachCell((cell, ci) => {
          const col = headers[ci - 1]
          const isNumeric = col?.type === "Amount" || col?.type === "Numeric"
          cell.alignment = { horizontal: isNumeric ? "right" : "left", indent: !isNumeric && ci === 1 ? depth : 0 }
          if (isNumeric) cell.numFmt = numFmtStr
        })
      } else {
        const rowData = headers.map((h, i) => {
          if (i === 0) return ""
          const val = row[h.dataIndex]
          if (h.type === "Amount" || h.type === "Numeric") return parseFloat(val || 0)
          return val ?? ""
        })
        const excelRow = ws.addRow(rowData)
        excelRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFFFF" } }
        excelRow.eachCell((cell, ci) => {
          const col = headers[ci - 1]
          const isNumeric = col?.type === "Amount" || col?.type === "Numeric"
          cell.alignment = { horizontal: isNumeric ? "right" : "left", indent: !isNumeric && ci === 1 ? depth : 0 }
          if (isNumeric) cell.numFmt = numFmtStr
        })
      }
    })

    // ── Grand total row ────────────────────────────────────────────────────
    if (showGrandTotal) {
      const grandTotalData = headers.map((h, i) => {
        if (i === 0) return "Grand Total"
        if (numericDataIndexes.includes(h.dataIndex)) return parseFloat(grandTotals[h.dataIndex] || 0)
        return ""
      })
      const grandTotalRow = ws.addRow(grandTotalData)
      grandTotalRow.font = { bold: true }
      grandTotalRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD6DCE4" } }
      grandTotalRow.eachCell((cell, ci) => {
        const col = headers[ci - 1]
        const isNumeric = col?.type === "Amount" || col?.type === "Numeric"
        cell.alignment = { horizontal: isNumeric ? "right" : "left" }
        if (isNumeric) cell.numFmt = numFmtStr
      })
    }

    headers.forEach((_, i) => { ws.getColumn(i + 1).width = 22 })

    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `${reportName || "DrillDown_Report"}.xlsx`
    a.click()
    URL.revokeObjectURL(url)
  }

  const exportDrillDownToPDF = () => {
    const { headers, flatRows, grandTotals, effectiveLevelFields, numericDataIndexes, showGrandTotal } = getDrillDownExportData()
    if (!headers.length) { message.error("No data to export"); return }

    const userPrefs = JSON.parse(localStorage.getItem("userPreferences"))
    const decimals = userPrefs?.decimalPlaces || 2
    const fmtNum = (v) => parseFloat(v || 0).toLocaleString("en-US", { minimumFractionDigits: decimals, maximumFractionDigits: decimals })

    const colCount = headers.length
    const colWidth = Math.max(25, Math.floor(270 / colCount))
    const pageWidth = Math.max(colCount * colWidth + 20, 297)
    const doc = new jsPDF({ orientation: "l", unit: "mm", format: [210, pageWidth] })

    doc.setFontSize(12)
    doc.text(reportName || "DrillDown Report", 10, 14)
    doc.setFontSize(8)
    doc.text(`Generated on: ${new Date().toLocaleString()}`, 10, 21)

    const body = []
    const bodyStyles = []

    flatRows.forEach(({ type, depth, group, row }) => {
      if (type === "group") {
        // Key always in col 0 (mirrors DrillDownTable: all group keys in first column)
        const showSubtotal = group.levelConfig?.showSubtotal !== false
        const pdfRow = headers.map((h, i) => {
          if (i === 0) return group.key || ""
          if (showSubtotal && numericDataIndexes.includes(h.dataIndex)) return fmtNum(group.subtotals[h.dataIndex])
          return ""
        })
        body.push(pdfRow)
        bodyStyles.push({ fontStyle: "bold", fillColor: pdfGroupFill[depth] || [245, 245, 245] })
      } else if (type === "leaf") {
        // Deepest level: plain row — key in col 0, subtotals in numeric cols
        const showSubtotal = group.levelConfig?.showSubtotal !== false
        const pdfRow = headers.map((h, i) => {
          if (i === 0) return group.key || ""
          if (showSubtotal && numericDataIndexes.includes(h.dataIndex)) return fmtNum(group.subtotals[h.dataIndex])
          return ""
        })
        body.push(pdfRow)
        bodyStyles.push({ fontStyle: "normal", fillColor: [255, 255, 255] })
      } else {
        const pdfRow = headers.map((h, i) => {
          if (i === 0) return ""
          const val = row[h.dataIndex]
          if (h.type === "Amount" || h.type === "Numeric") return fmtNum(val)
          return val ?? ""
        })
        body.push(pdfRow)
        bodyStyles.push({ fontStyle: "normal", fillColor: [255, 255, 255] })
      }
    })

    if (showGrandTotal) {
      body.push(headers.map((h, i) => {
        if (i === 0) return "Grand Total"
        if (numericDataIndexes.includes(h.dataIndex)) return fmtNum(grandTotals[h.dataIndex])
        return ""
      }))
      bodyStyles.push({ fontStyle: "bold", fillColor: [214, 220, 228] })
    }

    const columnStyles = {}
    headers.forEach((h, i) => {
      columnStyles[i] = { cellWidth: colWidth, halign: h.type === "Amount" || h.type === "Numeric" ? "right" : "left" }
    })

    doc.autoTable({
      head: [headers.map((h) => getColTitle(h))],
      body,
      startY: 28,
      styles: { fontSize: 7, cellPadding: 2, overflow: "linebreak" },
      headStyles: { fillColor: [68, 114, 196], textColor: [255, 255, 255], fontStyle: "bold", fontSize: 7 },
      columnStyles,
      didParseCell: (data) => {
        if (data.section === "body") {
          const style = bodyStyles[data.row.index]
          if (style) {
            data.cell.styles.fontStyle = style.fontStyle
            data.cell.styles.fillColor = style.fillColor
          }
        }
      },
      margin: { left: 10, right: 10 },
    })

    doc.save(`${reportName || "DrillDown_Report"}.pdf`)
  }

  const handleDrillDownExport = (exportType) => {
    if (exportType === "Excel") exportDrillDownToExcel()
    else if (exportType === "PDF") exportDrillDownToPDF()
  }

  const downloadOptions = (id) => (
    <Menu>
      <Menu.Item key="excel" onClick={() => downloadData("Excel", id)}>
        Excel
      </Menu.Item>
      <Menu.Item key="pdf" onClick={() => downloadData("PDF", id)}>
        PDF
      </Menu.Item>
    </Menu>
  )

  const pivotExportOptions = (
    <Menu>
      <Menu.Item key="excel" onClick={() => handlePivotExport("Excel")}>
        Excel
      </Menu.Item>
      <Menu.Item key="pdf" onClick={() => handlePivotExport("PDF")}>
        PDF
      </Menu.Item>
    </Menu>
  )

  const drillDownExportOptions = (
    <Menu>
      <Menu.Item key="excel" onClick={() => handleDrillDownExport("Excel")}>
        Excel
      </Menu.Item>
      <Menu.Item key="pdf" onClick={() => handleDrillDownExport("PDF")}>
        PDF
      </Menu.Item>
    </Menu>
  )

  const columnsforReportScheduler = [
    {
      title: "",
      dataIndex: "",
      width: 80,
      render: (text, row) => (
        <span>
          <span
            style={{ cursor: "pointer" }}
            role="presentation"
            onClick={() => {
              editScheduledReport(text)
            }}
          >
            <EditOutlined />
          </span>
          <span>
            &nbsp;&nbsp;&nbsp;
            <span style={{ cursor: "pointer" }} role="presentation" onClick={() => deleteScheduledReport(text)}>
              <DeleteOutlined />
            </span>
          </span>
        </span>
      ),
    },
    {
      title: "No",
      dataIndex: "srNo",
    },
    {
      title: "Created By",
      dataIndex: "createdByName",
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
    },
    {
      title: "Last Run Date",
      dataIndex: "lastRunDate",
    },
  ]

  const selectTimeLineFilters = (value) => {
    switch (value) {
      case "today": {
        const today = moment();

        if (dateRangeColumnName.type === "Date" || dateRangeColumnName.type === "DateTime") {
          // Single DatePicker
          form.setFieldsValue({
            [dateRangeColumnName.value]: today,
          });
        } else {
          // RangePicker
          form.setFieldsValue({
            [dateRangeColumnName.value]: [today, today],
          });
        }

        formattedDateForButton(today.toDate(), today.toDate());
        break;
      }

      case "yesterday": {
        const yesterday = moment().subtract(1, "day");

        if (dateRangeColumnName.type === "Date" || dateRangeColumnName.type === "DateTime") {
          form.setFieldsValue({
            [dateRangeColumnName.value]: yesterday,
          });
        } else {
          form.setFieldsValue({
            [dateRangeColumnName.value]: [yesterday, yesterday],
          });
        }

        formattedDateForButton(yesterday.toDate(), yesterday.toDate());
        break;
      }
      case "lastSevenDays":
        const currDate = new Date()
        const lastSevenDay = dateConvertor(new Date(Date.now() - 6 * 24 * 60 * 60 * 1000))
        form.setFieldsValue({
          [dateRangeColumnName.value]: [
            moment(new Date(lastSevenDay), dateFormat),
            moment(new Date(currDate), dateFormat),
          ],
        })
        formattedDateForButton(lastSevenDay, currDate)
        break
      case "lastThirtyDays":
        const currDateForThirtyDays = new Date()
        const last30Day = dateConvertor(new Date(Date.now() - 29 * 24 * 60 * 60 * 1000))
        form.setFieldsValue({
          [dateRangeColumnName.value]: [
            moment(new Date(last30Day), dateFormat),
            moment(new Date(currDateForThirtyDays), dateFormat),
          ],
        })
        formattedDateForButton(last30Day, currDateForThirtyDays)
        break
      case "lastNinetyDays":
        const startDateForLastNinetyDays = dateConvertor(moment().subtract(90, "days"))
        const endDateForLastNinetyDays = dateConvertor(new Date())
        form.setFieldsValue({
          [dateRangeColumnName.value]: [
            moment(new Date(startDateForLastNinetyDays), dateFormat),
            moment(new Date(), dateFormat),
          ],
        })
        formattedDateForButton(startDateForLastNinetyDays, endDateForLastNinetyDays)
        break
      case "lastMonth":
        const lastMonthDate = new Date()
        const lastMonthFirstDay = dateConvertor(new Date(lastMonthDate.getFullYear(), lastMonthDate.getMonth() - 1, 1))
        const lastMonthLastDay = dateConvertor(new Date(lastMonthDate.getFullYear(), lastMonthDate.getMonth(), 0))
        form.setFieldsValue({
          [dateRangeColumnName.value]: [
            moment(new Date(lastMonthFirstDay), dateFormat),
            moment(new Date(lastMonthLastDay), dateFormat),
          ],
        })
        formattedDateForButton(lastMonthFirstDay, lastMonthLastDay)
        break
      case "lastYear":
        if (userCurrency === "INR") {
          const currDateCurrency = new Date()
          const fiscalYearFirstDay = dateConvertor(new Date(currDateCurrency.getFullYear() - 1, 3, 1))
          const fiscalYearLastDay = dateConvertor(new Date(currDateCurrency.getFullYear(), 2, 31))
          form.setFieldsValue({
            [dateRangeColumnName.value]: [
              moment(new Date(fiscalYearFirstDay), dateFormat),
              moment(new Date(fiscalYearLastDay), dateFormat),
            ],
          })
          formattedDateForButton(fiscalYearFirstDay, fiscalYearLastDay)
        } else {
          const lastYearDate = new Date(new Date().getFullYear() - 1, 0, 1)
          const lastYearFirstDay = dateConvertor(new Date(lastYearDate.getFullYear(), 0, 1))
          const lastYearLastDay = dateConvertor(new Date(lastYearDate.getFullYear(), 11, 31))
          form.setFieldsValue({
            [dateRangeColumnName.value]: [
              moment(new Date(lastYearFirstDay), dateFormat),
              moment(new Date(lastYearLastDay), dateFormat),
            ],
          })
          formattedDateForButton(lastYearFirstDay, lastYearLastDay)
        }
        break
      case "thisWeek":
        const curr = new Date()
        const week = []
        for (let i = 1; i <= 7; i++) {
          const first = curr.getDate() - curr.getDay() + i
          const day = new Date(curr.setDate(first)).toISOString().slice(0, 10)
          week.push(day)
        }
        const firstday = dateConvertor(week[0])
        const lastday = dateConvertor(new Date())
        form.setFieldsValue({
          [dateRangeColumnName.value]: [moment(new Date(firstday), dateFormat), moment(new Date(), dateFormat)],
        })
        formattedDateForButton(firstday, lastday)
        break
      case "thisMonth":
        const date = new Date()
        const year = date.getFullYear()
        const month = date.getMonth()
        const firstDay = dateConvertor(new Date(year, month, 1))
        const lastDay = dateConvertor(new Date())
        form.setFieldsValue({
          [dateRangeColumnName.value]: [moment(new Date(firstDay), dateFormat), moment(new Date(lastDay), dateFormat)],
        })
        formattedDateForButton(firstDay, lastDay)
        break
      case "thisQuarter":
        const startDateOfQuarter = dateConvertor(moment().startOf("quarter"))
        const endDateOfQuarter = dateConvertor(new Date())
        form.setFieldsValue({
          [dateRangeColumnName.value]: [
            moment(new Date(startDateOfQuarter), dateFormat),
            moment(new Date(), dateFormat),
          ],
        })
        formattedDateForButton(startDateOfQuarter, endDateOfQuarter)
        break
      case "thisYear":
        if (userCurrency === "INR") {
          const today = new Date()
          const fiscalYearFirstDayForYearToDate = dateConvertor(new Date(today.getFullYear(), 3, 1))
          form.setFieldsValue({
            [dateRangeColumnName.value]: [
              moment(new Date(fiscalYearFirstDayForYearToDate), dateFormat),
              moment(new Date(), dateFormat),
            ],
          })
          formattedDateForButton(fiscalYearFirstDayForYearToDate, dateConvertor(today))
        } else {
          const currentDate = new Date()
          const theFirst = dateConvertor(new Date(currentDate.getFullYear(), 0, 1))
          form.setFieldsValue({
            [dateRangeColumnName.value]: [moment(new Date(theFirst), dateFormat), moment(new Date(), dateFormat)],
          })
          formattedDateForButton(theFirst, currentDate)
        }
        break
      default:
        message.info("Select proper timeline filter")
        break
    }
  }

  const dateConvertor = (str) => {
    const date = new Date(str)
    const mnth = ("0" + (date.getMonth() + 1)).slice(-2)
    const day = ("0" + date.getDate()).slice(-2)
    return [date.getFullYear(), mnth, day].join("-")
  }

  const formattedDateForButton = (fromDate, toDate) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    const startDate = new Date(fromDate)
    const startDateDay = startDate.getDate()
    const startDateMonth = monthNames[startDate.getMonth()]
    const startDateYear = startDate.getFullYear()
    const endDate = new Date(toDate)
    const endDateDay = endDate.getDate()
    const endDateMonth = monthNames[endDate.getMonth()]
    const endDateYear = endDate.getFullYear()
    const formattedStartDate = `${startDateMonth} ${startDateDay}`
    const formattedEndDate = `${endDateMonth} ${endDateDay}`
    const fullFormattedDate = `${formattedStartDate}-${formattedEndDate}, ${endDateYear}`
    setButtonName(fullFormattedDate)
  }

  const nonDrilldownQueries =
    reportData?.analyticsReportConfiguration?.queryConfiguration?.filter((query) => query.isDrilldownQuery !== "Y") ||
    []

  const executeData = () => {
    if (
      reportData.analyticsReportConfiguration.type === "multilevel" &&
      !reportSelector &&
      nonDrilldownQueries.length > 1
    ) {
      message.warning("Please select a report to run")
      return
    }
    form.submit()
  }

  const navigationFunction = (element, record) => {
    for (let index = 0; index < reportData.analyticsReportConfiguration.queryConfiguration.length; index++) {
      const query = reportData.analyticsReportConfiguration.queryConfiguration[index]
      const reportFields = query.outputFields
      for (let j = 0; j < reportFields.length; j++) {
        const reportFieldElement = reportFields[j]

        if (reportFieldElement.id === element.navigation_field_id) {
          const { navigationFieldName } = reportFieldElement
          const navigationWindowId = element.navigation_window_id
          const specificWindowId = record[navigationFieldName]
          window.open(
            `/popupWindow/${navigationWindowId}/${specificWindowId}`,
            "_blank",
            "resizable=yes, scrollbars=yes, titlebar=yes, width=800, height=900, top=10, left=10",
          )
        }
      }
    }
  }

  const drillDown = async (parametersData, fieldName, record, drillDownId) => {
    try {
      const parametersFromState = parametersData
      const replacedString = parametersFromState.replace(/\\/g, "")
      const parsedJson = JSON.parse(replacedString)
      parsedJson[fieldName] = record
      for (const [key, value] of Object.entries(parsedJson)) {
        if (value === null) {
          delete parsedJson[key]
        }
      }
      const stringifiedJSON = JSON.stringify(parsedJson)
      const jsonToSend = stringifiedJSON.replace(/"/g, '\\"')
      setReportParameters(jsonToSend)
      const { access_token } = getOAuthHeaders()
      if (drillDownId !== null) {
        setDrillDownId(drillDownId)
        setLoading(true)
        const headers = {
          "Content-Type": "application/json",
          Authorization: `bearer ${access_token}`,
          appId: appId,
        }
        setLoadingForModal(true)
        const getReportDetailsQuery = {
          query: `query {
                        getReportJson(reportId:"${drillDownId}"){data, messageCode, title, message}
                    }`,
        }

        const getReportJsonServerResponse = await Axios.post(
          genericUrl,
          getReportDetailsQuery,
          { headers: headers },
          { async: true },
          { crossDomain: true },
        )
        const reportJsonResponse = getReportJsonServerResponse.data.data.getReportJson

        if (reportJsonResponse.messageCode === "201") {
          setLoading(false)
          message.error(reportJsonResponse.message)
        } else {
          const reportData = JSON.parse(reportJsonResponse.data)
          const reportName = reportData.name
          setPopUpReportName(reportName)
          const drillDownFields = reportData.Fields
          const onSubmitQuery = {
            query: `query {
                            executeReport(parentReportId:"${reportId}",reportId:"${drillDownId}", reportParam:"${jsonToSend}"){data, messageCode, title, message}
                        }`,
          }

          const serverResponse = await Axios.post(
            genericUrl,
            onSubmitQuery,
            { headers: headers },
            { async: true },
            { crossDomain: true },
          )
          const reportResponse = serverResponse.data.data.executeReport
          if (reportResponse.title === "Success") {
            setLoading(false)
            setLoadingForModal(false)
            const gridData = JSON.parse(reportResponse.data)
            setGridLength(gridData.length)
            if (gridData.length > 0) {
              const headerArrayForDrillDown = []
              const getGridLogicResponse = gridLogic(gridData, drillDownFields)
              const { finalArrayToPush, finalGridData, totalRecords } = getGridLogicResponse

              for (let index = 0; index < finalArrayToPush.length; index += 1) {
                const element = finalArrayToPush[index]
                headerArrayForDrillDown.push({
                  title: (
                    <div
                      className="dragHandler"
                      style={{ textAlign: finalArrayToPush[index].type === "Numeric" ? "right" : "left" }}
                    >
                      {element.displayName}
                    </div>
                  ),
                  dataIndex: element.fieldName,
                  type: element.type,
                  drillDown: element.drillDown,
                  enableNavigation: element.enableNavigation,
                  detailReportId: element.detailReportId,
                  navigation_field_id: element.navigationFieldId,
                  navigation_window_id: element.navigationWindowId,
                  render: (text) =>
                    finalArrayToPush[index].drillDown === "Y" ? (
                      <a style={{ color: "#1A0DAB", textDecoration: "underline" }}>{text}</a>
                    ) : (
                      <div style={{ textAlign: finalArrayToPush[index].type === "Numeric" ? "right" : "left" }}>
                        {finalArrayToPush[index].type === "Numeric"
                          ? text === undefined || text === null
                            ? ""
                            : text.toLocaleString("en-US")
                          : text}
                      </div>
                    ),
                  sorter: (a, b) =>
                    (a[finalArrayToPush[index].fieldName] !== null || b[finalArrayToPush[index].fieldName] !== null) &&
                      (a[finalArrayToPush[index].fieldName] !== undefined ||
                        b[finalArrayToPush[index].fieldName] !== undefined)
                      ? finalArrayToPush[index].type === "Numeric"
                        ? a[finalArrayToPush[index].fieldName] - b[finalArrayToPush[index].fieldName]
                        : a[finalArrayToPush[index].fieldName].length - b[finalArrayToPush[index].fieldName].length
                      : "",
                  onCell: (record) => ({
                    onClick: () => {
                      if (finalArrayToPush[index].drillDown === "Y") {
                        drillDown(
                          jsonToSend,
                          finalArrayToPush[index].fieldName,
                          record[finalArrayToPush[index].fieldName],
                          finalArrayToPush[index].detailReportId,
                        )
                      } else if (finalArrayToPush[index].enableNavigation === "Y") {
                        navigationFunction(finalArrayToPush[index], record)
                      }
                    },
                  }),
                  width:
                    finalArrayToPush[index].gridlength === undefined || finalArrayToPush[index].gridlength === null
                      ? 100
                      : Number.parseInt(finalArrayToPush[index].gridlength),
                  ellipsis: true,
                })
              }
              setHeaderForDrillDown(headerArrayForDrillDown)
              setDataForDrillDown(finalGridData)
              setDrillDownTitle(record)
              setPopupForDrillDown(true)
              setFullScreen(false)
              setTotalRecordsForDrillDown(totalRecords)
            } else {
              message.error("No Data Available")
              setLoading(false)
              setLoadingForModal(false)
            }
          } else if (reportResponse.title === "Error") {
            message.error(reportResponse.message)
            setLoadingForModal(false)
            setLoading(false)
          }
        }
      }
    } catch (error) {
      const { message } = JSON.parse(JSON.stringify(error))
      if (
        message === "Network error: Unexpected token < in JSON at position 0" ||
        message === "Request failed with status code 401"
      ) {
        generateToken()
      } else {
        return Promise.reject(error)
      }
    }
  }
  console.log(form.getFieldsValue(true), "----->values")
  const onFinish = async (values) => {
    try {
      setGridData([])
      setHeaderData([])
      setMainHeaderData([])
      setTotalRecords([])
      setPivotColumns([])
      setShowGridData(false)
      setLoading(true)
      console.log(values, "----->values", form.getFieldsValue(true))
      const arrayToSend = { ...form.getFieldsValue(true) }
      let dateArr = []
      let startDateForDateRange, endDateForDateRange
      for (const [key, value] of Object.entries(arrayToSend)) {
        const currentFilter = reportFiltersForDatePopup.find((f) => f.columnName === key)
        const filterType = currentFilter ? currentFilter.type : null

        if (!value) {
          if (
            key === dateRangeColumnName.value &&
            (dateRangeColumnName.type === "DateRange" || dateRangeColumnName.type === "DateTimeRange")
          ) {
            if (!defaultValueExpression || defaultValueExpression === "nodate") {
              const monthsDate = new Date()
              const monthsYear = monthsDate.getFullYear()
              const monthData = monthsDate.getMonth()
              startDateForDateRange = dateConvertor(new Date(monthsYear, monthData, 1))
              endDateForDateRange = dateConvertor(new Date(monthsYear, monthData + 1, 0))
              dateArr = [startDateForDateRange, endDateForDateRange]
              arrayToSend[key] = dateArr
              arrayToSend["_dateRange"] = "nodate"
            } else {
              switch (defaultValueExpression) {
                case "today":
                  startDateForDateRange = dateConvertor(new Date())
                  dateArr = [startDateForDateRange, startDateForDateRange]
                  arrayToSend[key] = dateArr
                  arrayToSend["_dateRange"] = "today"
                  break
                case "yesterday":
                  startDateForDateRange = dateConvertor(new Date(new Date().getTime() - 24 * 60 * 60 * 1000))
                  dateArr = [startDateForDateRange, startDateForDateRange]
                  arrayToSend[key] = dateArr
                  arrayToSend["_dateRange"] = "yesterday"
                  break
                case "lastSevenDays":
                  endDateForDateRange = dateConvertor(new Date())
                  startDateForDateRange = dateConvertor(new Date(Date.now() - 6 * 24 * 60 * 60 * 1000))
                  dateArr = [startDateForDateRange, endDateForDateRange]
                  arrayToSend[key] = dateArr
                  arrayToSend["_dateRange"] = "lastSevenDays"
                  break
                case "lastThirtyDays":
                  endDateForDateRange = dateConvertor(new Date())
                  startDateForDateRange = dateConvertor(new Date(Date.now() - 29 * 24 * 60 * 60 * 1000))
                  dateArr = [startDateForDateRange, endDateForDateRange]
                  arrayToSend[key] = dateArr
                  arrayToSend["_dateRange"] = "lastThirtyDays"
                  break
                case "lastNinetyDays":
                  startDateForDateRange = dateConvertor(moment().subtract(90, "days"))
                  endDateForDateRange = dateConvertor(new Date())
                  dateArr = [startDateForDateRange, endDateForDateRange]
                  arrayToSend[key] = dateArr
                  arrayToSend["_dateRange"] = "lastNinetyDays"
                  break
                case "lastMonth":
                  const lastMonthDate = new Date()
                  startDateForDateRange = dateConvertor(new Date(lastMonthDate.getFullYear(), lastMonthDate.getMonth() - 1, 1))
                  endDateForDateRange = dateConvertor(new Date(lastMonthDate.getFullYear(), lastMonthDate.getMonth(), 0))
                  dateArr = [startDateForDateRange, endDateForDateRange]
                  arrayToSend[key] = dateArr
                  arrayToSend["_dateRange"] = "lastMonth"
                  break
                case "lastYear":
                  if (userCurrency === "INR") {
                    const currDateCurrency = new Date()
                    startDateForDateRange = dateConvertor(new Date(currDateCurrency.getFullYear() - 1, 3, 1))
                    endDateForDateRange = dateConvertor(new Date(currDateCurrency.getFullYear(), 2, 31))
                  } else {
                    const lastYearDate = new Date(new Date().getFullYear() - 1, 0, 1)
                    startDateForDateRange = dateConvertor(new Date(lastYearDate.getFullYear(), 0, 1))
                    endDateForDateRange = dateConvertor(new Date(lastYearDate.getFullYear(), 11, 31))
                  }
                  dateArr = [startDateForDateRange, endDateForDateRange]
                  arrayToSend[key] = dateArr
                  arrayToSend["_dateRange"] = "lastYear"
                  break
                case "thisWeek":
                  const curr = new Date()
                  const week = []
                  for (let i = 1; i <= 7; i++) {
                    const first = curr.getDate() - curr.getDay() + i
                    const day = new Date(curr.setDate(first)).toISOString().slice(0, 10)
                    week.push(day)
                  }
                  startDateForDateRange = dateConvertor(week[0])
                  endDateForDateRange = dateConvertor(new Date())
                  dateArr = [startDateForDateRange, endDateForDateRange]
                  arrayToSend[key] = dateArr
                  arrayToSend["_dateRange"] = "thisWeek"
                  break
                case "thisMonth":
                  const date = new Date()
                  const year = date.getFullYear()
                  const month = date.getMonth()
                  startDateForDateRange = dateConvertor(new Date(year, month, 1))
                  endDateForDateRange = dateConvertor(new Date())
                  dateArr = [startDateForDateRange, endDateForDateRange]
                  arrayToSend[key] = dateArr
                  arrayToSend["_dateRange"] = "thisMonth"
                  break
                case "thisQuarter":
                  startDateForDateRange = dateConvertor(moment().startOf("quarter"))
                  endDateForDateRange = dateConvertor(new Date())
                  dateArr = [startDateForDateRange, endDateForDateRange]
                  arrayToSend[key] = dateArr
                  arrayToSend["_dateRange"] = "thisQuarter"
                  break
                case "thisYear":
                  if (userCurrency === "INR") {
                    const currentDate = new Date()
                    startDateForDateRange = dateConvertor(new Date(currentDate.getFullYear(), 3, 1))
                    endDateForDateRange = dateConvertor(currentDate)
                  } else {
                    const currentDate = new Date()
                    startDateForDateRange = dateConvertor(new Date(currentDate.getFullYear(), 0, 1))
                    endDateForDateRange = dateConvertor(currentDate)
                  }
                  dateArr = [startDateForDateRange, endDateForDateRange]
                  arrayToSend[key] = dateArr
                  arrayToSend["_dateRange"] = "thisYear"
                  break
              }
            }
          } else if (
            key === dateRangeColumnName.value &&
            (dateRangeColumnName.type === "Date" || dateRangeColumnName.type === "DateTime")
          ) {
            startDateForDateRange = dateConvertor(new Date())
            arrayToSend[key] = startDateForDateRange
            arrayToSend["_dateRange"] = "today"
          } else {
            delete arrayToSend[key]
          }
        } else if (filterType === "DateRange" || filterType === "DateTimeRange") {
          // Send local datetime without UTC conversion
          const format = filterType === "DateTimeRange" ? "YYYY-MM-DDTHH:mm:ss.SSS" : "YYYY-MM-DD"
          arrayToSend[key] = value.map((date) => moment(date).format(format))
          if (key === dateRangeColumnName.value) {
            arrayToSend["_dateRange"] = values._dateRange || "custom"
          }
        } else if (filterType === "Date" || filterType === "DateTime") {
          // Send local datetime without UTC conversion
          const format = filterType === "DateTime" ? "YYYY-MM-DDTHH:mm:ss.SSS" : "YYYY-MM-DD"
          arrayToSend[key] = moment(value).format(format)
          if (key === dateRangeColumnName.value) {
            arrayToSend["_dateRange"] = values._dateRange || "custom"
          }
        }
      }
      console.log(arrayToSend, "----->arrayToSend")
      setParametersToSend(arrayToSend)
      const stringifiedJSON = JSON.stringify(arrayToSend)
      const jsonToSend = stringifiedJSON.replace(/"/g, '\\"')
      const { access_token } = getOAuthHeaders()
      const headers = {
        "Content-Type": "application/json",
        Authorization: `bearer ${access_token}`,
        appId: appId,
      }
      const queries = reportData.analyticsReportConfiguration.queryConfiguration.filter(
        (query) => query.isDrilldownQuery !== "Y",
      )
      const allGridData = []
      const allHeaderData = []
      const allMainHeaderData = []
      const allPivotColumns = []
      const allTotalRecords = []
      let hasData = false
      const selectedQuery =
        reportData.analyticsReportConfiguration.type === "multilevel" && reportSelector
          ? queries.find((q) => q.id === reportSelector)
          : null

      for (let i = 0; i < queries.length; i++) {
        const query = queries[i]
        if (
          reportData.analyticsReportConfiguration.type === "multilevel" &&
          query.id !== reportSelector &&
          reportSelector
        )
          continue
        if (reportData.analyticsReportConfiguration.type !== "multilevel" || !reportSelector) {
          // Process all queries for "standard" type or when no selector is chosen
        }
        const queryId = query.id
        const reportFields = query.outputFields
        // console.log(`Processing query: ${query.name} (ID: ${queryId})`)
        const onSubmitQuery = {
          query: `query {
                        executeAnalyticsReport(
                            reportId: "${reportId}",
                            queryId: "${queryId}",
                            reportParam: "${jsonToSend}"
                        ) {
                            data
                            messageCode
                            title
                            message
                        }
                    }`,
        }
        try {
          const serverResponse = await Axios.post(genericUrl, onSubmitQuery, { headers: headers })
          if (serverResponse.data.data.executeAnalyticsReport.messageCode === "200") {
            const responseForGridData = serverResponse.data.data.executeAnalyticsReport.data
            const gridData = JSON.parse(responseForGridData)

            // console.log(`Query ${queryId} response data:`, gridData)
            if (gridData.length > 0) {
              const headerArray = []
              const getGridLogicResponse = gridLogic(gridData, reportFields)
              const { finalArrayToPush, finalGridData, totalRecords } = getGridLogicResponse
              // console.log(`Query ${queryId} gridLogic output:`, { finalArrayToPush, finalGridData, totalRecords })
              finalArrayToPush.sort((a, b) => a.sequence_no - b.sequence_no)
              allPivotColumns.push({ queryId, columns: finalArrayToPush })
              for (let index = 0; index < finalArrayToPush.length; index++) {
                const column = finalArrayToPush[index]
                const type = column.type
                let align = "left"
                if (type === "Numeric" || type === "Amount") align = "right"
                else if (type === "Date") align = "center"
                headerArray.push({
                  title: <div className="dragHandler">{column.displayName}</div>,
                  dataIndex: column.fieldName,
                  align,
                  type: column.type,
                  checked: true,
                  isactive: column.isactive === "Y",
                  hidden: column.fieldName === "p_supplier_id",
                  width: column.gridLength ? Number.parseInt(column.gridLength) : 180,
                  ellipsis: true,
                  drillDown: column.drillDown,
                  enableNavigation: column.enableNavigation,
                  detailReportId: column.detailReportId,
                  navigation_field_id: column.navigationFieldId,
                  navigation_window_id: column.navigationWindowId,
                  fieldName: column.navigationFieldName,
                  sorter: (a, b) => {
                    if (!a[column.fieldName] || !b[column.fieldName]) return 0
                    if (column.type === "Numeric") {
                      return a[column.fieldName] - b[column.fieldName]
                    } else if (column.type === "Date") {
                      return (
                        new Date(a[column.fieldName].split("-").reverse().join("-")) -
                        new Date(b[column.fieldName].split("-").reverse().join("-"))
                      )
                    } else {
                      return a[column.fieldName].length - b[column.fieldName].length
                    }
                  },
                  render: (text) => (
                    <div style={{ whiteSpace: "break-spaces" }}>
                      {column.type === "Numeric" ? (text ?? "").toLocaleString("en-US") : text}
                    </div>
                  ),
                  onCell: (record) => ({
                    onClick: () => {
                      if (column.drillDown === "Y") {
                        drillDown(jsonToSend, column.fieldName, record[column.fieldName], column.detailReportId)
                      } else if (column.enableNavigation === "Y") {
                        navigationFunction(column, record)
                      }
                    },
                  }),
                })
              }
              const visibleHeaders = headerArray.filter((item) => item.isactive)
              // console.log(`Query ${queryId} headers:`, visibleHeaders)
              allGridData.push({ queryId, data: finalGridData })
              allHeaderData.push({ queryId, headers: visibleHeaders })
              allMainHeaderData.push({ queryId, headers: headerArray })
              allTotalRecords.push({ queryId, total: totalRecords })
              hasData = true
            } else {
              // console.log(`Query ${queryId} returned no data`)
              allGridData.push({ queryId, data: [] })
              allHeaderData.push({ queryId, headers: [] })
              allMainHeaderData.push({ queryId, headers: [] })
              allTotalRecords.push({ queryId, total: 0 })
            }
          } else {
            console.error(
              `Query ${queryId} failed with message:`,
              serverResponse.data.data.executeAnalyticsReport.message,
            )
            message.error(serverResponse.data.data.executeAnalyticsReport.message)
            allGridData.push({ queryId, data: [] })
            allHeaderData.push({ queryId, headers: [] })
            allMainHeaderData.push({ queryId, headers: [] })
            allTotalRecords.push({ queryId, total: 0 })
          }
        } catch (error) {
          const { message } = JSON.parse(JSON.stringify(error))
          console.error(`Error executing query ${queryId}:`, message)
          if (
            message === "Network error: Unexpected token < in JSON at position 0" ||
            message === "Request failed with status code 401"
          ) {
            generateToken()
          } else {
            message.error(`Error executing query ${query.name}: ${message}`)
          }
          allGridData.push({ queryId, data: [] })
          allHeaderData.push({ queryId, headers: [] })
          allMainHeaderData.push({ queryId, headers: [] })
          allTotalRecords.push({ queryId, total: 0 })
        }
      }
      console.log("Final state updates:", {
        allGridData,
        allHeaderData,
        allMainHeaderData,
        allPivotColumns,
        allTotalRecords,
      })
      setGridData(allGridData)
      setHeaderData(allHeaderData)
      setMainHeaderData(allMainHeaderData)
      setPivotColumns(allPivotColumns)
      setTotalRecords(allTotalRecords)
      setShowGridData(hasData)
      setLoading(false)
      setDrawerVisible(false)
    } catch (error) {
      console.error("Error in onFinish:", error)
      message.error("An error occurred while executing the report.")
      setLoading(false)
    }
  }

  const dateMenu = (
    <Card style={{ padding: "8px" }}>
      <Form preserve={false} layout="vertical" form={form} onFinish={onFinish}>
        {reportDateOptionsFlag ? (
          <Row>
            <Col span={24}>
              <Form.Item label="Date Range" name="_dateRange" rules={[{ required: false }]}>
                <Select
                  allowClear
                  showSearch
                  placeholder="---Select timeline---"
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  dropdownMatchSelectWidth={false}
                  onSelect={selectTimeLineFilters}
                >
                  {dateRangeColumnName.type === "DateRange" || dateRangeColumnName.type === "DateTimeRange" ? (
                    <>
                      <Option key="1" value="today">
                        Today
                      </Option>
                      <Option key="2" value="yesterday">
                        Yesterday
                      </Option>
                      <Option key="3" value="lastSevenDays">
                        Last 7 days
                      </Option>
                      <Option key="4" value="lastThirtyDays">
                        Last 30 days
                      </Option>
                      <Option key="5" value="lastNinetyDays">
                        Last 90 days
                      </Option>
                      <Option key="6" value="lastMonth">
                        Last month
                      </Option>
                      <Option key="7" value="lastYear">
                        Last year
                      </Option>
                      <Option key="8" value="thisWeek">
                        Week to date
                      </Option>
                      <Option key="9" value="thisMonth">
                        Month to date
                      </Option>
                      <Option key="10" value="thisQuarter">
                        Quarter to date
                      </Option>
                      <Option key="11" value="thisYear">
                        Year to date
                      </Option>
                    </>
                  ) : (
                    <>
                      <Option key="1" value="today">
                        Today
                      </Option>
                      <Option key="2" value="yesterday">
                        Yesterday
                      </Option>
                    </>
                  )}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        ) : null}
        <br />
        <Row gutter={8}>
          {reportFiltersForDatePopup?.map((filtersData, index) => (
            <Col
              span={24}
              key={index}
              style={{ display: filtersData.type === "DateRange" || filtersData.type === "Date" || filtersData.type === "DateTimeRange" || filtersData.type === "DateTime" ? "block" : "none" }}
            >
              <Form.Item
                label={filtersData.displayName}
                name={filtersData.columnName}
                rules={[
                  {
                    required: filtersData.mandatory === "N" ? false : true,
                    message: `Please Enter ${filtersData.displayName}`,
                  },
                ]}
              >
                {filtersData.type === "DateRange" || filtersData.type === "DateTimeRange" ? (
                  <RangePicker
                    format={filtersData.type === "DateTimeRange" ? `${dateFormat} HH:mm:ss` : dateFormat}
                    showTime={filtersData.type === "DateTimeRange" ? { format: 'HH:mm:ss' } : false}
                    onChange={rangeDateChange}
                    onFocus={focusedRangePicker}
                    style={{ width: "100%" }}
                  />
                ) : filtersData.type === "Date" || filtersData.type === "DateTime" ? (
                  <DatePicker
                    format={filtersData.type === "DateTime" ? `${dateFormat} HH:mm:ss` : dateFormat}
                    showTime={filtersData.type === "DateTime" ? { format: 'HH:mm:ss' } : false}
                    onChange={onDateChange}
                    onFocus={focusedDatePicker}
                    style={{ width: "100%" }}
                  />
                ) : null}
              </Form.Item>
              <br />
            </Col>
          ))}
        </Row>
      </Form>
    </Card>
  )

  const appliedFilters = form.getFieldsValue(true)
  const filterText =
    Object.entries(appliedFilters)
      .filter(([key]) => key !== dateRangeColumnName.value && key !== "_dateRange")
      .map(([key, value]) => {
        const filter = reportFilters.find((f) => f.columnName === key)
        return filter ? `${filter.displayName}: ${value || "N/A"}` : null
      })
      .filter(Boolean)
      .join(", ") || "No filters applied"

  const showDrawer = () => {
    setDrawerVisible(true)
  }

  const onCloseDrawer = () => {
    setDrawerVisible(false)
  }

  const editScheduledReport = (text) => {
    const data1 = JSON.parse(text.scheduleinfo)
    const startDate = moment(text.startDate).format("YYYY-MM-DD HH:mm:ss")
    scheduleReportForm.setFieldsValue({
      recipient: data1.recipients,
      startdate_time: moment(startDate),
      frequency: text.frequency,
    })
    setSelectedRecordToUpdate(text)
  }

  const deleteScheduledReport = (text) => {
    const { access_token } = getOAuthHeaders()
    setloadingForSReport(true)
    const deleteReport = {
      query: `mutation{
          deleteScheduleReport(cSReportScheduleId:"${text.cSReportScheduleId}") 
          {
              messageCode
              message
          }
      }`,
    }
    Axios({
      url: genericUrl,
      method: "POST",
      data: deleteReport,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${access_token}`,
        appId: appId,
      },
    }).then((response) => {
      if (response.data.data.deleteScheduleReport.messageCode === "200") {
        message.success(response.data.data.deleteScheduleReport.message)
        setloadingForSReport(false)
        getExistigScheduleData()
      } else {
        message.error(response.data.data.deleteScheduleReport.message)
        setloadingForSReport(false)
      }
    })
  }

  const getReportScheduler = () => {
    form.validateFields().then((values) => {
      const formData = form.getFieldsValue(true)
      setBasescreenFormData(formData)
      setReportSchedulerVisible(true)
      getExistigScheduleData()
    })
  }

  const closeReportScheduler = () => {
    setReportSchedulerVisible(false)
    scheduleReportForm.resetFields()
    setSelectedRecordToUpdate(null)
  }

  const onConfirmScheduleReport = () => {
    const { access_token } = getOAuthHeaders()
    scheduleReportForm.validateFields().then((values) => {
      setloadingForSReport(true)
      const formData = scheduleReportForm.getFieldsValue(true)
      const start_date = moment(formData.startdate_time).format("YYYY-MM-DD HH:mm:ss")
      const allparams = {
        params: basescreenFormData,
        recipients: formData._recipient,
      }
      const stringifiedJSON = JSON.stringify(allparams)
      const jsonToSend = stringifiedJSON.replace(/"/g, '\\"')
      const upsertScheduleReports = {
        query: `mutation{
          upsertScheduleReport(reportSchedule:{ 
              cSReportScheduleId:${selectedRecordToupdate === null || selectedRecordToupdate === undefined
            ? null
            : `"${selectedRecordToupdate.cSReportScheduleId}"`
          }
              csReportId:"${reportId}"
              frequency:"${formData.frequency}"
              scheduleinfo:"${jsonToSend}"
              startDate:"${start_date}"
              nextSchDate:${selectedRecordToupdate === null || selectedRecordToupdate === undefined
            ? null
            : `"${selectedRecordToupdate.nextSchDate}"`
          }
              lastRunDate:${selectedRecordToupdate === null || selectedRecordToupdate === undefined
            ? null
            : `"${selectedRecordToupdate.lastRunDate}"`
          }
          })
          {
              messageCode
              message
          }
      }`,
      }
      Axios({
        url: genericUrl,
        method: "POST",
        data: upsertScheduleReports,
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${access_token}`,
          appId: appId,
        },
      }).then((response) => {
        if (response.data.data.upsertScheduleReport.messageCode === "200") {
          message.success(response.data.data.upsertScheduleReport.message)
          setloadingForSReport(false)
          setReportSchedulerVisible(false)
          setSelectedRecordToUpdate(null)
          scheduleReportForm.resetFields()
        } else {
          message.error(response.data.data.upsertScheduleReport.message)
          setloadingForSReport(false)
        }
      })
    })
  }

  const isPivotReport = reportData.analyticsReportConfiguration.type === "pivot"
  const isDrillDownReport = reportData.analyticsReportConfiguration.type === "drillDown"
  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: "52px" }} spin />} spinning={loading}>
      <div>
        <style>
          {`
                    .report-tables-container::-webkit-scrollbar {
                        width: 8px;
                        height: 8px;
                    }
                    .report-tables-container::-webkit-scrollbar-track {
                        background-color: #f1f1f1;
                    }
                    .report-tables-container::-webkit-scrollbar-thumb {
                        background-color: #C1C1C1;
                        border-radius: 5px;
                        min-width: 8px;
                        max-width: 8px;
                        min-height: 8px;
                        max-height: 8px;
                    }
                    .report-tables-container::-webkit-scrollbar-thumb:hover {
                        background-color: #7D7D7D;
                    }
                    `}
        </style>
        <Row style={{ marginTop: "-5px" }}>
          <Col span={8}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span className="formRecordTitle" style={{ fontWeight: "600", fontSize: "20px", fontFamily: "Inter" }}>
                {reportName}
              </span>
            </div>
          </Col>
          <Col span={16}>
            <span style={{ float: "right" }}>
              {showGridData && (
                <Tooltip placement="top" title="Show Filters">
                  <img
                    style={{ cursor: "pointer" }}
                    src={listMode || "/placeholder.svg"}
                    alt="clear"
                    onClick={showDrawer}
                  />
                </Tooltip>
              )}
              {scheduledReportFlag === true ? (
                <Tooltip placement="topLeft" title="Report Scheduler">
                  <img
                    style={{ cursor: "pointer" }}
                    onClick={getReportScheduler}
                    src={ReportIcon || "/placeholder.svg"}
                    alt="reportscheduler"
                  />
                  &nbsp;
                </Tooltip>
              ) : null}
              <Tooltip placement="top" title="Clear">
                <img
                  style={{ cursor: "pointer" }}
                  src={clearReportData || "/placeholder.svg"}
                  alt="clear"
                  onClick={() => form.resetFields()}
                />
              </Tooltip>
              {dateRangeColumnName.type && reportDateOptionsFlag ? (
                <span style={{ marginRight: "8px" }}>
                  <Dropdown
                    overlay={dateMenu}
                    trigger={["click"]}
                    visible={filterDropdownVisible}
                    onVisibleChange={handleFilterDropdownVisibleChange}
                  >
                    <Tag className="tagReport" style={{ cursor: "pointer" }}>
                      <span style={{ fontWeight: "600", fontSize: "12px" }}>Date Range: {buttonName}</span>
                      <CalendarOutlined />
                    </Tag>
                  </Dropdown>
                </span>
              ) : null}

              {/* Export button - different behavior for pivot / drilldown / regular reports */}
              <span style={{ marginRight: "1vw", display: reportData.analyticsReportConfiguration.type === "dashboard" ? "none" : undefined }}>
                {isPivotReport ? (
                  <Dropdown overlay={pivotExportOptions} trigger={["click"]}>
                    <Button
                      disabled={!pivotExportData || pivotExportData.length === 0}
                      type="primary"
                      icon={<DownloadOutlined />}
                      style={{
                        height: "30px",
                        borderRadius: "4px",
                        padding: "0 2vw",
                        fontFamily: "Inter",
                        fontWeight: 700,
                        color: "#FFFFFF",
                      }}
                    >
                      Export As
                    </Button>
                  </Dropdown>
                ) : isDrillDownReport ? (
                  <Dropdown
                    overlay={drillDownExportOptions}
                    trigger={["click"]}
                    disabled={!gridData[0]?.data?.length}
                  >
                    <Button
                      disabled={!gridData[0]?.data?.length}
                      type="primary"
                      icon={<DownloadOutlined />}
                      style={{
                        height: "30px",
                        backgroundColor: "#000",
                        borderRadius: "4px",
                        padding: "0 2vw",
                        fontFamily: "Inter",
                        fontWeight: 700,
                        color: "#FFFFFF",
                      }}
                    >
                      Export As
                    </Button>
                  </Dropdown>
                ) : (
                  <Button
                    type="primary"
                    onClick={() => setShowExportPopup(true)}
                    style={{
                      height: "30px",
                      borderRadius: "4px",
                      padding: "0 2vw",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      color: "#FFFFFF",
                    }}
                  >
                    Export As
                  </Button>
                )}
              </span>

              {showExportPopup && !isPivotReport && (
                <ExportPopup
                  exportType="AnalyticsReport"
                  exportLabel={reportName}
                  reportId={reportId}
                  totalRecords={500}
                  onClose={() => setShowExportPopup(false)}
                  showExportPopup={showExportPopup}
                  setShowExportPopup={setShowExportPopup}
                  inputJson={form.getFieldsValue(true)}
                  isAnalyticsReport={true}
                />
              )}

              <Button
                style={{
                  height: "30px",
                  borderRadius: "4px",
                  padding: "0 2vw",
                  fontFamily: "Inter",
                  fontWeight: 700,
                  color: "#FFFFFF",
                }}
                type="primary"
                onClick={executeData}
              >
                Run
              </Button>
            </span>
          </Col>
        </Row>
        <Row gutter={8} style={{ marginTop: "1%", display: showGridData ? "none" : "" }}>
          <Col span={24}>
            <Form preserve={false} form={form} layout="vertical" onFinish={onFinish}>
              <Row gutter={8}>
                {reportData.analyticsReportConfiguration.type === "multilevel" && nonDrilldownQueries.length > 1 && (
                  <Col span={6}>
                    <Form.Item
                      style={{
                        fontFamily: "Inter",
                        fontWeight: "bold",
                        color: Themes.appTheme.primaryColor,
                        background: "white",
                        padding: "1% 3% 3% 3%",
                        borderRadius: "5px",
                        border: "1px solid #D3D3D3",
                      }}
                      label="Select Report"
                    >
                      <Select
                        placeholder="Select a report"
                        onChange={handleQueryChange}
                        value={reportSelector}
                      >
                        {nonDrilldownQueries.map((query) => (
                          <Option key={query.id} value={query.id}>
                            {query.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                )}
                {reportFilters?.map((filtersData, index) => (
                  <Col
                    span={6}
                    key={index}
                    style={{
                      display:
                        filtersData.isForPrompting === "N" ||
                          filtersData.isactive === "N" ||
                          filtersData.type === "DateRange" ||
                          filtersData.type === "Date" ||
                          filtersData.type === "DateTimeRange" ||
                          filtersData.type === "DateTime"
                          ? "none"
                          : "block",
                    }}
                  >
                    <Form.Item
                      style={{
                        fontFamily: "Inter",
                        fontWeight: "bold",
                        color: Themes.appTheme.primaryColor,
                        background: "white",
                        padding: "1% 3% 3% 3%",
                        borderRadius: "5px",
                        border: "1px solid #D3D3D3",
                      }}
                      label={
                        filtersData.type === "DateRange" || filtersData.type === "Date" || filtersData.type === "DateTimeRange" || filtersData.type === "DateTime" ? null : filtersData.displayName
                      }
                      name={
                        filtersData.type === "DateRange" || filtersData.type === "Date" || filtersData.type === "DateTimeRange" || filtersData.type === "DateTime" ? null : filtersData.columnName
                      }
                      rules={[
                        {
                          required:
                            filtersData.mandatory === "N" ||
                              filtersData.type === "DateRange" ||
                              filtersData.type === "Date" ||
                              filtersData.type === "DateTimeRange" ||
                              filtersData.type === "DateTime"
                              ? false
                              : true,
                          message: `Please Enter ${filtersData.displayName}`,
                        },
                      ]}
                    >
                      {filtersData.type === "MultiSelector" ? (
                        <Select
                          className="report-select"
                          style={{ width: "100%" }}
                          onSearch={searchDropdownRecords}
                          mode="multiple"
                          maxTagCount={1}
                          dropdownStyle={{ width: "12%" }}
                          showSearch
                          allowClear
                          placeholder={
                            <>
                              <span style={{ fontFamily: "Inter", fontSize: 12 }}>Select</span>
                              <img src={arrowIcon || "/placeholder.svg"} style={{ float: "right", marginTop: 10 }} />
                            </>
                          }
                          dropdownMatchSelectWidth={false}
                          filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                          onFocus={() => onDropDownSelect(filtersData.id, filtersData.dependentId)}
                        >
                          {dropdownDetails?.map((data) => (
                            <Option key={data.recordid} value={data.recordid ?? data.name}>
                              {data.name}
                            </Option>
                          ))}
                        </Select>
                      ) :
                        filtersData.type === "Selector" ? (
                          <Select
                            showSearch
                            onSearch={searchDropdownRecords}
                            allowClear
                            dropdownStyle={{ width: "12%" }}
                            // notFoundContent={fetching ? <Spin size="small" /> : null}
                            dropdownMatchSelectWidth={false}
                            style={{ width: "100%", borderRadius: '4px' }}
                            placeholder={<span style={{ fontFamily: 'Inter', fontSize: 12 }}>Select</span>}
                            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            onFocus={() => onDropDownSelect(filtersData.id, filtersData.dependentId)}
                          >
                            {dropdownDetails === null || dropdownDetails === undefined
                              ? null
                              : dropdownDetails.map((data) => {
                                return (
                                  <Option key={data.recordid} value={data.recordid === undefined || data.recordid === null ? data.name : data.recordid}>
                                    {data.name}
                                  </Option>
                                );
                              })}
                          </Select>
                        ) : filtersData.type === "List" ? (
                          <Select
                            showSearch
                            allowClear
                            dropdownStyle={{ width: "12%" }}
                            // notFoundContent={fetching ? <Spin size="small" /> : null}
                            placeholder={<span style={{ fontFamily: 'Inter', fontSize: 12 }}>Select</span>}
                            dropdownMatchSelectWidth={false}
                            style={{ width: "100%" }}
                            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            onFocus={() => onDropDownSelectForListReference(filtersData.Values)}
                          >
                            {referenceListDetails === null || referenceListDetails === undefined
                              ? null
                              : referenceListDetails.map((data) => {
                                return (
                                  <Option key={data.key} title={data.key} value={data.key}>
                                    {data.value}
                                  </Option>
                                );
                              })}
                          </Select>
                        ) : null}
                    </Form.Item>
                    <br />
                  </Col>
                ))}
              </Row>
            </Form>
          </Col>
        </Row>
        <div
          className="report-tables-container"
          style={{
            maxHeight: "78vh",
            overflowY: "auto",
            overflowX: "auto",
            padding: "0 8px",
            paddingBottom: "3vh",
          }}
        >
          {/* Dashboard report — KPI cards (badge / table / bar / line) */}
          {showGridData && reportData.analyticsReportConfiguration.type === "dashboard" && (
            <div style={{ padding: "8px" }}>
              <DashboardReport kpis={reportData.analyticsReportConfiguration.kpis || []} gridData={gridData} />
            </div>
          )}
          <Row gutter={8} style={{ marginTop: 7 }}>
            {showGridData &&
              reportData.analyticsReportConfiguration.type !== "dashboard" &&
              gridData.map((dataItem, index) => {
                const query = reportData.analyticsReportConfiguration.queryConfiguration.find(
                  (q) => q.id === dataItem.queryId,
                )
                // Optional: Log to verify non-drilldown queries
                console.log(`Rendering query: ${query.name}, isDrilldownQuery: ${query.isDrilldownQuery}`)
                if (query.isDrilldownQuery === "Y") return null // Skip drilldown queries
                const headerItem = headerData[index] || { headers: [] }

                // Check if this is a pivot report
                const isPivotReport = reportData.analyticsReportConfiguration.type === "pivot"
                const pivotConfig = reportData.analyticsReportConfiguration.displayConfiguration?.pivotConfig

                return (
                  <Col
                    className="reportCol"
                    span={24}
                    key={dataItem.queryId}
                    style={{ marginBottom: "8px", padding: 0 }}
                  >
                    <Card
                      bodyStyle={{
                        paddingBottom: "0px",
                        padding: "1% 0 1% 1%",
                        maxHeight: "auto",
                        overflowY: "auto",
                        overflowX: "auto",
                      }}
                      style={{ marginBottom: "16px" }}
                    >
                      {reportData.analyticsReportConfiguration.type === "multilevel" && nonDrilldownQueries.length > 1 ? (
                        <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                          <Select
                            placeholder="Select a report"
                            onChange={handleQueryChange}
                            value={reportSelector}
                            style={{
                              width: "auto",
                              fontWeight: "700",
                              fontSize: "16px",
                              color: Themes.appTheme.primaryColor
                            }}
                            className="query-selector-dropdown-title"
                            bordered={false}
                            suffixIcon={<EditOutlined style={{ fontSize: '14px', color: Themes.appTheme.primaryColor }} />}
                          >
                            {nonDrilldownQueries.map((q) => (
                              <Option key={q.id} value={q.id}>
                                {q.name}
                              </Option>
                            ))}
                          </Select>
                        </div>
                      ) : (
                        <Typography.Title level={4} style={{ marginBottom: "3px", fontSize: "10px" }}>
                          {query?.name || `Query ${index + 1}`}
                        </Typography.Title>
                      )}
                      {console.log(
                        dataItem.data.length > 0 && headerItem.headers.length > 0,
                        isPivotReport && pivotConfig,
                      )}
                      {dataItem.data.length > 0 && headerItem.headers.length > 0 ? (
                        isPivotReport && pivotConfig ? (
                          <PivotTableForAnalytics
                            columnsData={headerItem.headers}
                            gridData={dataItem.data}
                            pivotConfig={pivotConfig}
                            onExportDataReady={setPivotExportData}
                          />
                        ) :
                          isDrillDownReport ? (
                            <DrillDownTable
                              columnsData={headerItem.headers}
                              gridData={dataItem.data}
                              reportFields={
                                reportData.analyticsReportConfiguration.queryConfiguration.find(
                                  (q) => q.id === dataItem.queryId,
                                ).outputFields
                              }
                              columnGrouping={
                                reportData.analyticsReportConfiguration.queryConfiguration.find(
                                  (q) => q.id === dataItem.queryId,
                                ).columnGroups
                              }
                              groupingConfiguration={
                                reportData.analyticsReportConfiguration.queryConfiguration.find(
                                  (q) => q.id === dataItem.queryId,
                                ).groupingConfiguration
                              }
                              parametersToSend={JSON.stringify(parametersToSend).replace(/"/g, '\\"')}
                              fullScreen={false}
                              onDrillDown={drillDown}
                              onNavigation={navigationFunction}
                              selectedLevel={drillDownSelectedLevel}
                              onLevelChange={setDrillDownSelectedLevel}
                            />
                          ) : (
                            <AnalyticsReportTable
                              columnsData={headerItem.headers}
                              gridData={dataItem.data}
                              reportFields={
                                reportData.analyticsReportConfiguration.queryConfiguration.find(
                                  (q) => q.id === dataItem.queryId,
                                ).outputFields
                              }
                              nestedTableFlag={nestedTable}
                              parametersToSend={JSON.stringify(parametersToSend).replace(/"/g, '\\"')}
                              detailedReportId={detailedReportId}
                              mainReportId={reportId}
                              viewMoreLessFilter={viewMoreLessFilters}
                              reportFiltersForNextRowLength={reportFiltersForNextRow.length}
                              totalRecords={totalRecords[index]?.total || 0}
                              fullScreen={false}
                              groupingConfiguration={
                                reportData.analyticsReportConfiguration.queryConfiguration.find(
                                  (q) => q.id === dataItem.queryId,
                                ).groupingConfiguration
                              }
                              columnGrouping={
                                reportData.analyticsReportConfiguration.queryConfiguration.find(
                                  (q) => q.id === dataItem.queryId,
                                ).columnGroups
                              }
                              onDrillDown={drillDown}
                              onNavigation={navigationFunction}
                            />
                          )
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "400px",
                          }}
                        >
                          <img
                            style={{ opacity: 0.2, marginBottom: "1em" }}
                            src={noRecord || "/placeholder.svg"}
                            alt=""
                          />
                          <span
                            style={{
                              fontFamily: "Inter",
                              fontWeight: 700,
                              color: "#425B6D",
                              opacity: 0.7,
                              fontSize: "20px",
                              textAlign: "center",
                            }}
                          >
                            No Reports to Display
                          </span>
                          <span
                            style={{
                              fontFamily: "Inter",
                              fontWeight: 400,
                              color: "#425B6D",
                              opacity: 0.7,
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                          >
                            Please select filter to generate report
                          </span>
                        </div>
                      )}
                    </Card>
                  </Col>
                )
              })}
            {!showGridData && (
              <Col className="reportCol" span={24} style={{ marginBottom: "8px", padding: 0 }}>
                <Card
                  style={{ backgroundColor: "#f5f5f6", border: "none" }}
                  bodyStyle={{
                    backgroundColor: "#f3f4f9",
                    border: "none",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60vh",
                    boxSizing: "border-box",
                  }}
                >
                  <img style={{ opacity: 0.2, marginBottom: "1em" }} src={noRecord || "/placeholder.svg"} alt="" />
                  <span
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 700,
                      color: "#425B6D",
                      opacity: 0.7,
                      fontSize: "20px",
                      textAlign: "center",
                    }}
                  >
                    No Reports to Display
                  </span>
                  <span
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 400,
                      color: "#425B6D",
                      opacity: 0.7,
                      fontSize: "14px",
                      textAlign: "center",
                    }}
                  >
                    Please select filter to generate report
                  </span>
                </Card>
              </Col>
            )}
          </Row>
        </div>
        <div style={{ marginTop: 7 }}>
          <Modal
            id="reportAntModal"
            title={
              <Spin indicator={<LoadingOutlined style={{ fontSize: "10px" }} spin />} spinning={loadingForModal}>
                <Row>
                  <Col span={16} style={{ fontWeight: "bold", fontStyle: "normal", textAlign: "start" }}>
                    {popUpReportName} - {drillDownTitle}
                  </Col>
                  <Col span={8} style={{ textAlign: "end" }}>
                    <img
                      style={{ cursor: "pointer", paddingTop: "3px", height: fullScreen ? "2.7vh" : "" }}
                      src={fullScreen ? closeIcon : fullScreenIcon || "/placeholder.svg"}
                      alt="invoice"
                      onClick={() => {
                        setFullScreen(!fullScreen)
                      }}
                    />
                    &nbsp;&nbsp;&nbsp;
                    <img
                      style={{ cursor: "pointer", height: "3vh", paddingTop: "1px" }}
                      src={ExportPopup1 || "/placeholder.svg"}
                      alt="invoice"
                    />
                    &nbsp;
                    <img
                      src={Close || "/placeholder.svg"}
                      alt=""
                      style={{ cursor: "pointer", height: "4vh" }}
                      onClick={handleCancel}
                    />
                  </Col>
                </Row>
              </Spin>
            }
            className="tabModal"
            closable={false}
            visible={drillDownPopup}
            onCancel={handleCancel}
            bodyStyle={{ padding: 0 }}
            footer={null}
            centered
            width={fullScreen ? "98%" : "800px"}
          >
            <Spin indicator={<LoadingOutlined style={{ fontSize: "52px" }} spin />} spinning={loadingForModal}>
              <Card bodyStyle={{ paddingTop: "0px", paddingBottom: "0px" }}>
                {reportData.analyticsReportConfiguration.type !== "pivot" ? (
                  <TableForReport
                    columnsData={drillDownHeader}
                    gridData={drillDownData}
                    reportFields={reportFields}
                    nestedTableFlag={nestedTable}
                    parametersToSend={reportParameters}
                    detailedReportId={detailedReportId}
                    mainReportId={reportId}
                    viewMoreLessFilter={viewMoreLessFilters}
                    reportFiltersForNextRowLength={reportFiltersForNextRow.length}
                    totalRecords={totalRecordsForDrillDown}
                    fullScreen={fullScreen}
                    onDrillDown={drillDown}
                    onNavigation={navigationFunction}
                  />
                ) : (
                  <PivotTableForAnalytics
                    columnsData={drillDownHeader}
                    gridData={drillDownData}
                    pivotConfig={reportData.analyticsReportConfiguration.displayConfiguration?.pivotConfig}
                  />
                )}
              </Card>
            </Spin>
          </Modal>
        </div>
        <Drawer
          title={
            <div style={{ display: "flex", alignItems: "center", height: "6vh", padding: "1rem" }}>
              <p
                style={{
                  fontSize: "1.5vw",
                  margin: 0,
                  fontFamily: "Inter",
                  marginLeft: "0.8em",
                  fontWeight: "500",
                  color: "black",
                  flex: 1,
                  textAlign: "left",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Filters
              </p>
            </div>
          }
          placement="right"
          onClose={onCloseDrawer}
          visible={drawerVisible}
          width={320}
        >
          <Form preserve={false} form={form} layout="vertical" onFinish={onFinish}>
            <Row gutter={8}>
              {/* {reportData.analyticsReportConfiguration.type === "multilevel" && (
                <Col span={24} style={{ marginBottom: "4vh" }}>
                  <Form.Item
                    style={{
                      fontFamily: "Inter",
                      fontWeight: "bold",
                      color: Themes.appTheme.primaryColor,
                      background: "white",
                      padding: "1% 3% 3% 3%",
                      borderRadius: "5px",
                      border: "1px solid #D3D3D3",
                    }}
                    label="Select Report"
                  >
                    <Select
                      placeholder="Select a report"
                      onChange={handleQueryChange}
                      value={reportSelector}
                    >
                      {nonDrilldownQueries.map((query) => (
                        <Option key={query.id} value={query.id}>
                          {query.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
              <br /> */}
              {reportFilters?.map((filtersData, index) => (
                <Col
                  span={24}
                  key={index}
                  style={{
                    display:
                      filtersData.isForPrompting === "N" ||
                        filtersData.isactive === "N" ||
                        filtersData.type === "DateRange" ||
                        filtersData.type === "Date" ||
                        filtersData.type === "DateTime" ||
                        filtersData.type === "DateTimeRange"
                        ? "none"
                        : "block",
                  }}
                >
                  <Form.Item
                    style={{
                      fontFamily: "Inter",
                      fontWeight: "bold",
                      color: Themes.appTheme.primaryColor,
                      background: "white",
                      padding: "1% 3% 3% 3%",
                      borderRadius: "5px",
                      border: "1px solid #D3D3D3",
                    }}
                    label={
                      filtersData.type === "DateRange" || filtersData.type === "Date" ||
                        filtersData.type === "DateTime" ||
                        filtersData.type === "DateTimeRange" ? null : filtersData.displayName
                    }
                    name={
                      filtersData.type === "DateRange" || filtersData.type === "Date" ||
                        filtersData.type === "DateTime" ||
                        filtersData.type === "DateTimeRange" ? null : filtersData.columnName
                    }
                    rules={[
                      {
                        required:
                          filtersData.mandatory === "N" ||
                            filtersData.type === "DateRange" ||
                            filtersData.type === "Date" ||
                            filtersData.type === "DateTime" ||
                            filtersData.type === "DateTimeRange"
                            ? false
                            : true,
                        message: `Please Enter ${filtersData.displayName}`,
                      },
                    ]}
                  >
                    {filtersData.type === "MultiSelector" ? (
                      <Select
                        className="report-select"
                        style={{ width: "100%" }}
                        onSearch={searchDropdownRecords}
                        mode="multiple"
                        maxTagCount={1}
                        dropdownStyle={{ width: "12%" }}
                        showSearch
                        allowClear
                        placeholder={
                          <>
                            <span style={{ fontFamily: "Inter", fontSize: 12 }}>Select</span>
                            <img src={arrowIcon || "/placeholder.svg"} style={{ float: "right", marginTop: 10 }} />
                          </>
                        }
                        dropdownMatchSelectWidth={false}
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        onFocus={() => onDropDownSelect(filtersData.id, filtersData.dependentId)}
                      >
                        {dropdownDetails?.map((data) => (
                          <Option key={data.recordid} value={data.recordid ?? data.name}>
                            {data.name}
                          </Option>
                        ))}
                      </Select>
                    ) : null}
                  </Form.Item>
                  <br />
                </Col>
              ))}
            </Row>
            <Button type="primary" onClick={executeData} style={{ marginTop: "16px" }}>
              Apply Filters
            </Button>
          </Form>
        </Drawer>

        <div style={{ marginTop: 7 }}>
          <Modal
            title={"Schedule Report"}
            visible={reportSchedulerVisible}
            centered
            width="700px"
            onCancel={closeReportScheduler}
            footer={
              <>
                <Button type="default" onClick={closeReportScheduler}>
                  Cancel
                </Button>
                &nbsp;
                <Button
                  loading={loadingForSReport}
                  style={Themes.contentWindow.ListWindowHeader.newButtonForlist}
                  type="primary"
                  onClick={onConfirmScheduleReport}
                >
                  Save
                </Button>
              </>
            }
          >
            <Spin indicator={<LoadingOutlined style={{ fontSize: "52px" }} spin />} spinning={loadingForSReport}>
              <Form layout="vertical" name="control-hooks" style={{ padding: "8px" }} form={scheduleReportForm}>
                <Row>
                  <Col style={{ paddingRight: "8px" }} span={12}>
                    <Form.Item label="Frequency" name="frequency">
                      <Select
                        allowClear
                        showSearch
                        placeholder="---Select---"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        dropdownMatchSelectWidth={false}
                      >
                        <>
                          <Option key="DL" value="DL">
                            Daily
                          </Option>
                          <Option key="WK" value="WK">
                            Weekly
                          </Option>
                          <Option key="MT" value="MT">
                            Monthly
                          </Option>
                          <Option key="QT" value="QT">
                            Quarterly
                          </Option>
                          <Option key="YL" value="YL">
                            Yearly
                          </Option>
                        </>
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col style={{ paddingLeft: "8px" }} span={12}>
                    <Form.Item label="Start Date & Time" name="startdate_time">
                      <DatePicker style={{ width: "100%" }} showTime />
                    </Form.Item>
                  </Col>
                </Row>
                <br />
                <Row style={{ paddingBottom: "16px" }}>
                  <Col span={24}>
                    <Form.Item
                      label="Recipient"
                      name="_recipient"
                      rules={[
                        {
                          required: true,
                          message: "Please input recipient",
                        },
                      ]}
                    >
                      <TextArea />
                    </Form.Item>
                  </Col>
                </Row>
                <p style={{ marginBottom: "6px" }} />
                <p style={{ fontSize: "12px", marginBottom: "0px" }}>Current Schedules</p>
              </Form>
              <Row>
                <Col style={{ paddingRight: "8px", paddingLeft: "8px" }} span={24}>
                  <Table
                    size="small"
                    columns={columnsforReportScheduler}
                    dataSource={scheduledData}
                    pagination={false}
                  />
                </Col>
              </Row>
              <br />
            </Spin>
          </Modal>
        </div>
      </div>
    </Spin>
  )
}
